<template>
    <div class="theme-3">
      <div :class="'editorConPopOver'" v-if="showEditor == true">
        <div
          class="editorPopover"
          :style="{
            backgroundColor:
              selectedBackgroundColor === 'rgba(0, 0, 0, 0)'
                ? 'rgba(255, 255, 255, 1)'
                : selectedBackgroundColor,
          }">
          <h3
            :style="{
              color: selectedHeadingsColor,
              margin: '5px',
              fontWeight: 'bold',
            }">
            {{ popOverHeading }}
          </h3>
          <QuillEditor
            @ready= "onReady"
            :content="content"
            :class="['custom-editor', { 'border-red-500': wordLimitError }]"
            @update:content="updateContent"
            @text-change="onTextChange"
            contentType="html"
            theme="snow"
            :toolbar="[
              ['bold', 'italic', 'underline'],
  
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
  
              [{ align: [] }],
            ]"></QuillEditor>
          <div class="flex justify-between items-center">
            <div class="wordcount">
              <p v-if="textLimit != 9999">
                <b :class="{ 'text-red-500': currentWordCount > textLimit }">
                  {{ currentWordCount }} / {{ textLimit }} words
                </b>
              </p>
              <!-- Error message when word limit is exceeded -->
              <p v-if="wordLimitError" class="text-red-500 text-sm mt-1">
                {{ wordLimitError }}
              </p>
            </div>
            <div>
              <button
                class="text-white font-bold py-1 px-2 m-2 rounded"
                :style="{
                  backgroundColor: selectedHeadingsColor,
                }"
                @click="getData">
                Save
              </button>
              <button
                class="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-2 m-2 border border-gray-400 rounded shadow"
                @click="showEditor = false">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
  
      <section
        id="page_1"
        class="page relative d-flex fd-col theme-3-page-1 theme-page-TraditionalStyle"
        :style="{
          backgroundColor: selectedBackgroundColor,
          fontFamily: selectedFontFamily,
        }">
        <div class="d-flex h-1 w-full">
          <h1
            :style="{
              color: selectedHeadingsColor,
            }"
            class="w-60 HeaderContent mt-10">
            {{ organization.name }}
          </h1>
          <h4
            :style="{
              color: selectedHeadingsColor,
            }"
            class="w-40 HeaderContent mt-3">
            CASE FOR SUPPORT
          </h4>
        </div>
  
        <div
          @mouseover="showDeleteIcon = true"
          @mouseleave="showDeleteIcon = false"
          class="relative">
          <img
            class="page-1-img hover:p-0.5 hover:!dashed-border cursor-pointer"
            :src="getImg(0) ? getImg(0).image : logos[0]"
            @click="openFileInput('fileInputBrand')"
            alt="" />
  
          <p
            class="absolute right-0 text-2xl cursor-pointer bg-white rounded-full"
            style="padding: 6px; bottom: 345px"
            @click="deleteImage(getImg(0).id)"
            v-if="showDeleteIcon && getImg(0).id">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="12"
              viewBox="0 0 100 100">
              <line
                x1="10"
                y1="10"
                x2="90"
                y2="90"
                stroke="red"
                stroke-width="10" />
              <line
                x1="10"
                y1="90"
                x2="90"
                y2="10"
                stroke="red"
                stroke-width="10" />
            </svg>
          </p>
          <p
            class="absolute cursor-pointer bg-white rounded-full left-0"
            style="padding: 3px; bottom: 346px"
            @click="openCropModel(getImg(0) ? getImg(0).image : logos[0], 1)"
            v-if="showDeleteIcon">
            <svg
              height="17"
              viewBox="0 0 48 48"
              width="19"
              xmlns="http://www.w3.org/2000/svg"
              fill="black">
              <path d="M0 0h48v48h-48z" fill="none" />
              <path
                d="M34 30h4v-16c0-2.21-1.79-4-4-4h-16v4h16v16zm-20 4v-32h-4v8h-8v4h8v20c0 2.21 1.79 4 4 4h20v8h4v-8h8v-4h-32z" />
            </svg>
          </p>
  
          <input
            id="fileInputBrand"
            class="fileInput-hidden"
            type="file"
            name="file"
            aria-invalid="false"
            accept="image/png, image/jpeg, image/jpg"
            @change="(event) => updateLogo(1, event)" />
        </div>
      </section>
  
      <section
        id="page_2"
        class="page table-of-content theme-page-TraditionalStyle"
        :style="{
          backgroundColor: selectedBackgroundColor,
          fontFamily: selectedFontFamily,
        }">
        <h2
          class="HeaderContent"
          :style="{
            color: selectedHeadingsColor,
          }">
          Table of content
        </h2>
        <table class="w-1">
          <tbody>
            <tr>
              <td
                :style="{
                  color: selectedBodyTextColor,
                }">
                Letter From the Executive Director
              </td>
              <td
                :style="{
                  color: selectedHeadingsColor,
                }">
                3
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td
                :style="{
                  color: selectedBodyTextColor,
                }">
                Our Story
              </td>
              <td
                :style="{
                  color: selectedHeadingsColor,
                }">
                4
              </td>
            </tr>
            <tr>
              <td
                :style="{
                  color: selectedBodyTextColor,
                }">
                Our Vision
              </td>
              <td
                :style="{
                  color: selectedHeadingsColor,
                }">
                5
              </td>
            </tr>
            <tr>
              <td
                :style="{
                  color: selectedBodyTextColor,
                }">
                Our Mission
              </td>
              <td
                :style="{
                  color: selectedHeadingsColor,
                }">
                5
              </td>
            </tr>
            <tr>
              <td
                :style="{
                  color: selectedBodyTextColor,
                }">
                Current Programs
              </td>
              <td
                :style="{
                  color: selectedHeadingsColor,
                }">
                6
              </td>
            </tr>
            <tr>
              <td
                :style="{
                  color: selectedBodyTextColor,
                }">
                Call For More
              </td>
              <td
                :style="{
                  color: selectedHeadingsColor,
                }">
                {{
                  caseStatement?.case_statement_summary?.split(" ")?.length > 320
                    ? 8
                    : 7
                }}
              </td>
            </tr>
            <tr>
              <td
                :style="{
                  color: selectedBodyTextColor,
                }">
                Funding Priorities
              </td>
              <td
                :style="{
                  color: selectedHeadingsColor,
                }">
                {{
                  caseStatement?.case_statement_summary?.split(" ")?.length > 320
                    ? 10
                    : 9
                }}
              </td>
            </tr>
            <tr>
              <td
                :style="{
                  color: selectedBodyTextColor,
                }">
                Success Stories
              </td>
              <td
                :style="{
                  color: selectedHeadingsColor,
                }">
                {{
                  caseStatement?.case_statement_summary?.split(" ")?.length > 320
                    ? Math.floor(caseStatement.projects?.length / 2) + 1 + 10
                    : Math.floor(caseStatement.projects?.length / 2) + 1 + 9
                }}
              </td>
            </tr>
            <tr>
              <td
                :style="{
                  color: selectedBodyTextColor,
                }">
                Join Us
              </td>
              <td
                :style="{
                  color: selectedHeadingsColor,
                }">
                {{
                  caseStatement?.case_statement_summary?.split(" ")?.length > 320
                    ? Math.floor(caseStatement.projects?.length / 2) +
                      Math.floor(caseStatement.success_stories?.length / 2) +
                      12
                    : Math.floor(caseStatement.projects?.length / 2) +
                      Math.floor(caseStatement.success_stories?.length / 2) +
                      +11
                }}
              </td>
            </tr>
            <tr>
              <td
                :style="{
                  color: selectedBodyTextColor,
                }">
                Ways to Give
              </td>
              <td
                :style="{
                  color: selectedHeadingsColor,
                }">
                {{
                  caseStatement?.case_statement_summary?.split(" ")?.length > 320
                    ? Math.floor(caseStatement.projects?.length / 2) +
                      Math.floor(caseStatement.success_stories?.length / 2) +
                      12
                    : Math.floor(caseStatement.projects?.length / 2) +
                      Math.floor(caseStatement.success_stories?.length / 2) +
                      +11
                }}
              </td>
            </tr>
            <tr>
              <td
                :style="{
                  color: selectedBodyTextColor,
                }">
                Contact
              </td>
              <td
                :style="{
                  color: selectedHeadingsColor,
                }">
                {{
                  caseStatement?.case_statement_summary?.split(" ")?.length > 320
                    ? Math.floor(caseStatement.projects?.length / 2) +
                      Math.floor(caseStatement.success_stories?.length / 2) +
                      12
                    : Math.floor(caseStatement.projects?.length / 2) +
                      Math.floor(caseStatement.success_stories?.length / 2) +
                      +11
                }}
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="page-num"
          :style="{
            borderColor: selectedHeadingsColor,
            color: selectedHeadingsColor,
          }">
          2
        </div>
      </section>
  
      <section
        id="page_3"
        class="page letter-page theme-page-TraditionalStyle"
        :style="{
          backgroundColor: selectedBackgroundColor,
          fontFamily: selectedFontFamily,
        }">
        <div
          @mouseover="showDeleteIcon = true"
          @mouseleave="showDeleteIcon = false"
          class="relative">
          <img
            class="hover:p-0.5 hover:!dashed-border cursor-pointer"
            :src="getImg(1) ? getImg(1).image : logos[1]"
            @click="openFileInput('fileInput2')"
            alt="" />
  
          <p
            class="absolute top-2 right-2 text-2xl cursor-pointer bg-white rounded-full"
            style="padding: 6px"
            @click="deleteImage(getImg(1).id)"
            v-if="showDeleteIcon && getImg(1).id">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="12"
              viewBox="0 0 100 100">
              <line
                x1="10"
                y1="10"
                x2="90"
                y2="90"
                stroke="red"
                stroke-width="10" />
              <line
                x1="10"
                y1="90"
                x2="90"
                y2="10"
                stroke="red"
                stroke-width="10" />
            </svg>
          </p>
          <p
            v-if="showDeleteIcon"
            class="absolute top-2 cursor-pointer bg-white rounded-full left-2"
            style="padding: 3px"
            @click="openCropModel(getImg(1) ? getImg(1).image : logos[1], 2)">
            <svg
              height="17"
              viewBox="0 0 48 48"
              width="19"
              xmlns="http://www.w3.org/2000/svg"
              fill="black">
              <path d="M0 0h48v48h-48z" fill="none" />
              <path
                d="M34 30h4v-16c0-2.21-1.79-4-4-4h-16v4h16v16zm-20 4v-32h-4v8h-8v4h8v20c0 2.21 1.79 4 4 4h20v8h4v-8h8v-4h-32z" />
            </svg>
          </p>
  
          <input
            id="fileInput2"
            class="fileInput-hidden"
            type="file"
            name="file"
            aria-invalid="false"
            accept="image/png, image/jpeg, image/jpg"
            @change="(event) => updateLogo(2, event)" />
        </div>
        <div>
          <div class="my-1">
            <h2
              class="HeaderContent m-0"
              :style="{
                color: selectedHeadingsColor,
                paddingBottom: '7px'
              }">
              Letter From the Executive Director
            </h2>
          </div>
          <div class="edit-content hover:!dashed-border w-100 cursor-pointer">
            <div
              class="pre-text text-small BodyContent"
              :style="{
                color: selectedBodyTextColor,
                fontFamily: selectedFontFamily,
              }"
              v-html="
                caseStatement?.director_letter
                  ?.replace(/\n/g, '<br>')
                  .split(/\s+/)
                  .join(' ')
              "
              @click="
                setDynamicContent(
                  caseStatement?.director_letter,
                  caseStatement,
                  'director_letter',
                  'Letter From the Executive Director',
                  255
                )
              "></div>
          </div>
        </div>
        <div
          class="page-num"
          :style="{
            borderColor: selectedHeadingsColor,
            color: selectedHeadingsColor,
          }">
          3
        </div>
      </section>
  
      <section
        id="page_4"
        class="page theme-page-TraditionalStyle"
        :style="{
          backgroundColor: selectedBackgroundColor,
          fontFamily: selectedFontFamily,
        }">
        <div>
          <div>
            <h2
              class="HeaderContent mb-0"
              :style="{
                color: selectedHeadingsColor,
                marginBottom: '8px',
                marginTop: '0',
              }">
              Our Story
            </h2>
            <p
              class="edit-content BodyContent hover:!dashed-border mt-0 text-small cursor-pointer"
              :style="{
                color: selectedBodyTextColor,
              }"
              v-html="
                caseStatement?.our_story
                  ?.replace(/\n/g, '<br>')
                  .split(/\s+/)
                  .join(' ')
              "
              @click="
                setDynamicContent(
                  caseStatement.our_story,
                  caseStatement,
                  'our_story',
                  'Our Story',
                  294
                )
              "></p>
          </div>
          <div>
            <div class="page-bottom-image d-flex flex-wrap ">
              <div
                @mouseover="showDeleteIcon = true"
                @mouseleave="showDeleteIcon = false"
                class="relative ">
                <img
                  :src="getImg(2) ? getImg(2).image : logos[2]"
                  @click="openFileInput('fileInput3')"
                  class="hover:p-0.5 hover:!dashed-border cursor-pointer w-1 h-1"
                  alt="" />
                <p
                  class="absolute top-2 right-2 text-2xl cursor-pointer bg-white rounded-full"
                  style="padding: 6px"
                  @click="deleteImage(getImg(2).id)"
                  v-if="showDeleteIcon && getImg(2).id">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="12"
                    viewBox="0 0 100 100">
                    <line
                      x1="10"
                      y1="10"
                      x2="90"
                      y2="90"
                      stroke="red"
                      stroke-width="10" />
                    <line
                      x1="10"
                      y1="90"
                      x2="90"
                      y2="10"
                      stroke="red"
                      stroke-width="10" />
                  </svg>
                </p>
                <p
                  v-if="showDeleteIcon"
                  class="absolute top-2 cursor-pointer bg-white rounded-full left-2"
                  style="padding: 3px"
                  @click="
                    openCropModel(getImg(2) ? getImg(2).image : logos[2], 3)
                  ">
                  <svg
                    height="17"
                    viewBox="0 0 48 48"
                    width="19"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="black">
                    <path d="M0 0h48v48h-48z" fill="none" />
                    <path
                      d="M34 30h4v-16c0-2.21-1.79-4-4-4h-16v4h16v16zm-20 4v-32h-4v8h-8v4h8v20c0 2.21 1.79 4 4 4h20v8h4v-8h8v-4h-32z" />
                  </svg>
                </p>
                <input
                  id="fileInput3"
                  class="fileInput-hidden"
                  type="file"
                  name="file"
                  aria-invalid="false"
                  accept="image/png, image/jpeg, image/jpg"
                  @change="(event) => updateLogo(3, event)" />
              </div>
              <div
                @mouseover="showDeleteIcon = true"
                @mouseleave="showDeleteIcon = false"
                class="relative">
                <img
                  :src="getImg(3) ? getImg(3).image : logos[3]"
                  @click="openFileInput('fileInput4')"
                  class="hover:p-0.5 hover:!dashed-border cursor-pointer w-1 h-1"
                  alt="" />
                <p
                  class="absolute top-2 right-2 text-2xl cursor-pointer bg-white rounded-full"
                  style="padding: 6px"
                  @click="deleteImage(getImg(3).id)"
                  v-if="showDeleteIcon && getImg(3).id">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="12"
                    viewBox="0 0 100 100">
                    <line
                      x1="10"
                      y1="10"
                      x2="90"
                      y2="90"
                      stroke="red"
                      stroke-width="10" />
                    <line
                      x1="10"
                      y1="90"
                      x2="90"
                      y2="10"
                      stroke="red"
                      stroke-width="10" />
                  </svg>
                </p>
                <p
                  v-if="showDeleteIcon"
                  class="absolute top-2 cursor-pointer bg-white rounded-full left-2"
                  style="padding: 3px"
                  @click="
                    openCropModel(getImg(3) ? getImg(3).image : logos[3], 4)
                  ">
                  <svg
                    height="17"
                    viewBox="0 0 48 48"
                    width="19"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="black">
                    <path d="M0 0h48v48h-48z" fill="none" />
                    <path
                      d="M34 30h4v-16c0-2.21-1.79-4-4-4h-16v4h16v16zm-20 4v-32h-4v8h-8v4h8v20c0 2.21 1.79 4 4 4h20v8h4v-8h8v-4h-32z" />
                  </svg>
                </p>
                <input
                  id="fileInput4"
                  class="fileInput-hidden"
                  type="file"
                  name="file"
                  aria-invalid="false"
                  accept="image/png, image/jpeg, image/jpg"
                  @change="(event) => updateLogo(4, event)" />
              </div>
              <div
                @mouseover="showDeleteIcon = true"
                @mouseleave="showDeleteIcon = false"
                class="relative">
                <img
                  :src="getImg(4) ? getImg(4).image : logos[4]"
                  @click="openFileInput('fileInput5')"
                  class="hover:p-0.5 hover:!dashed-border cursor-pointer w-1 h-1"
                  alt="" />
                <p
                  class="absolute top-2 right-2 text-2xl cursor-pointer bg-white rounded-full"
                  style="padding: 6px"
                  @click="deleteImage(getImg(4).id)"
                  v-if="showDeleteIcon && getImg(4).id">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="12"
                    viewBox="0 0 100 100">
                    <line
                      x1="10"
                      y1="10"
                      x2="90"
                      y2="90"
                      stroke="red"
                      stroke-width="10" />
                    <line
                      x1="10"
                      y1="90"
                      x2="90"
                      y2="10"
                      stroke="red"
                      stroke-width="10" />
                  </svg>
                </p>
                <p
                  v-if="showDeleteIcon"
                  class="absolute top-2 cursor-pointer bg-white rounded-full left-2"
                  style="padding: 3px"
                  @click="
                    openCropModel(getImg(4) ? getImg(4).image : logos[4], 5)
                  ">
                  <svg
                    height="17"
                    viewBox="0 0 48 48"
                    width="19"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="black">
                    <path d="M0 0h48v48h-48z" fill="none" />
                    <path
                      d="M34 30h4v-16c0-2.21-1.79-4-4-4h-16v4h16v16zm-20 4v-32h-4v8h-8v4h8v20c0 2.21 1.79 4 4 4h20v8h4v-8h8v-4h-32z" />
                  </svg>
                </p>
                <input
                  id="fileInput5"
                  class="fileInput-hidden"
                  type="file"
                  name="file"
                  aria-invalid="false"
                  accept="image/png, image/jpeg, image/jpg"
                  @change="(event) => updateLogo(5, event)" />
              </div>
              <div
                @mouseover="showDeleteIcon = true"
                @mouseleave="showDeleteIcon = false"
                class="relative">
                <img
                  :src="getImg(5) ? getImg(5).image : logos[5]"
                  @click="openFileInput('fileInput6')"
                  class="hover:p-0.5 hover:!dashed-border cursor-pointer w-1 h-1"
                  alt="" />
  
                <p
                  class="absolute top-2 right-2 text-2xl cursor-pointer bg-white rounded-full"
                  style="padding: 6px"
                  @click="deleteImage(getImg(5).id)"
                  v-if="showDeleteIcon && getImg(5).id">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="12"
                    viewBox="0 0 100 100">
                    <line
                      x1="10"
                      y1="10"
                      x2="90"
                      y2="90"
                      stroke="red"
                      stroke-width="10" />
                    <line
                      x1="10"
                      y1="90"
                      x2="90"
                      y2="10"
                      stroke="red"
                      stroke-width="10" />
                  </svg>
                </p>
                <p
                  v-if="showDeleteIcon"
                  class="absolute top-2 cursor-pointer bg-white rounded-full left-2"
                  style="padding: 3px"
                  @click="
                    openCropModel(getImg(5) ? getImg(5).image : logos[5], 6)
                  ">
                  <svg
                    height="17"
                    viewBox="0 0 48 48"
                    width="19"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="black">
                    <path d="M0 0h48v48h-48z" fill="none" />
                    <path
                      d="M34 30h4v-16c0-2.21-1.79-4-4-4h-16v4h16v16zm-20 4v-32h-4v8h-8v4h8v20c0 2.21 1.79 4 4 4h20v8h4v-8h8v-4h-32z" />
                  </svg>
                </p>
                <input
                  id="fileInput6"
                  class="fileInput-hidden"
                  type="file"
                  name="file"
                  aria-invalid="false"
                  accept="image/png, image/jpeg, image/jpg"
                  @change="(event) => updateLogo(6, event)" />
              </div>
            </div>
          </div>
        </div>
        <div
          class="page-num-i"
          :style="{
            borderColor: selectedHeadingsColor,
            color: selectedHeadingsColor,
          }">
          4
        </div>
      </section>
  
      <section
        id="page_5"
        class="page our-mission-page theme-page-TraditionalStyle"
        :style="{
          backgroundColor: selectedBackgroundColor,
          fontFamily: selectedFontFamily,
        }">
        <div class="h-1 w-1 d-flex flex-wrap">
          <div class="w-2 h-2">
            <div
              @mouseover="showDeleteIcon = true"
              @mouseleave="showDeleteIcon = false"
              class="relative">
              <img
                class="hover:p-0.5 hover:!dashed-border cursor-pointer"
                :src="getImg(6) ? getImg(6).image : logos[6]"
                @click="openFileInput('fileInput7')"
                alt="" />
              <p
                class="absolute top-2 right-2 text-2xl cursor-pointer bg-white rounded-full"
                style="padding: 6px"
                @click="deleteImage(getImg(6).id)"
                v-if="showDeleteIcon && getImg(6).id">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="12"
                  viewBox="0 0 100 100">
                  <line
                    x1="10"
                    y1="10"
                    x2="90"
                    y2="90"
                    stroke="red"
                    stroke-width="10" />
                  <line
                    x1="10"
                    y1="90"
                    x2="90"
                    y2="10"
                    stroke="red"
                    stroke-width="10" />
                </svg>
              </p>
              <p
                v-if="showDeleteIcon"
                class="absolute top-2 cursor-pointer bg-white rounded-full left-2"
                style="padding: 3px"
                @click="openCropModel(getImg(6) ? getImg(6).image : logos[6], 7)">
                <svg
                  height="17"
                  viewBox="0 0 48 48"
                  width="19"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="black">
                  <path d="M0 0h48v48h-48z" fill="none" />
                  <path
                    d="M34 30h4v-16c0-2.21-1.79-4-4-4h-16v4h16v16zm-20 4v-32h-4v8h-8v4h8v20c0 2.21 1.79 4 4 4h20v8h4v-8h8v-4h-32z" />
                </svg>
              </p>
              <input
                id="fileInput7"
                class="fileInput-hidden"
                type="file"
                name="file"
                aria-invalid="false"
                accept="image/png, image/jpeg, image/jpg"
                @change="(event) => updateLogo(7, event)" />
            </div>
          </div>
          <div class="w-2 h-2 d-flex align-center j-center">
            <div class="p-3">
              <h2
                class="HeaderContent"
                :style="{
                  color: selectedHeadingsColor,
                }">
                Our Vision
              </h2>
              <div
                class="edit-content hover:!dashed-border BodyContent text-small cursor-pointer"
                :style="{
                  color: selectedBodyTextColor,
                }"
                v-html="
                  caseStatement.vision
                    ?.replace(/\n/g, '<br>')
                    .split(/\s+/)
                    .join(' ')
                "
                @click="
                  setDynamicContent(
                    caseStatement.vision,
                    caseStatement,
                    'vision',
                    'Our Vision',
                    70
                  )
                "></div>
            </div>
          </div>
          <div class="w-2 h-2 d-flex align-center j-center">
            <div class="p-3">
              <h2
                class="HeaderContent"
                :style="{
                  color: selectedHeadingsColor,
                }">
                Our Mission
              </h2>
              <div
                class="BodyContent hover:!dashed-border text-small edit-content cursor-pointer"
                :style="{
                  color: selectedBodyTextColor,
                }"
                v-html="
                  caseStatement.mission
                    ?.replace(/\n/g, '<br>')
                    .split(/\s+/)
                    .join(' ')
                "
                @click="
                  setDynamicContent(
                    caseStatement.mission,
                    caseStatement,
                    'mission',
                    'Our Mission',
                    70
                  )
                "></div>
            </div>
          </div>
          <div class="w-2 h-2">
            <div
              @mouseover="showDeleteIcon = true"
              @mouseleave="showDeleteIcon = false"
              class="relative">
              <img
                class="hover:p-0.5 hover:!dashed-border cursor-pointer"
                :src="getImg(7) ? getImg(7).image : logos[7]"
                @click="openFileInput('fileInput8')"
                alt="" />
              <p
                class="absolute top-2 right-2 text-2xl cursor-pointer bg-white rounded-full"
                style="padding: 6px"
                @click="deleteImage(getImg(7).id)"
                v-if="showDeleteIcon && getImg(7).id">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="12"
                  viewBox="0 0 100 100">
                  <line
                    x1="10"
                    y1="10"
                    x2="90"
                    y2="90"
                    stroke="red"
                    stroke-width="10" />
                  <line
                    x1="10"
                    y1="90"
                    x2="90"
                    y2="10"
                    stroke="red"
                    stroke-width="10" />
                </svg>
              </p>
              <p
                v-if="showDeleteIcon"
                class="absolute top-2 cursor-pointer bg-white rounded-full left-2"
                style="padding: 3px"
                @click="openCropModel(getImg(7) ? getImg(7).image : logos[7], 8)">
                <svg
                  height="17"
                  viewBox="0 0 48 48"
                  width="19"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="black">
                  <path d="M0 0h48v48h-48z" fill="none" />
                  <path
                    d="M34 30h4v-16c0-2.21-1.79-4-4-4h-16v4h16v16zm-20 4v-32h-4v8h-8v4h8v20c0 2.21 1.79 4 4 4h20v8h4v-8h8v-4h-32z" />
                </svg>
              </p>
              <input
                id="fileInput8"
                class="fileInput-hidden"
                type="file"
                name="file"
                aria-invalid="false"
                accept="image/png, image/jpeg, image/jpg"
                @change="(event) => updateLogo(8, event)" />
            </div>
          </div>
        </div>
        <div
          class="page-num"
          :style="{
            borderColor: selectedHeadingsColor,
            color: selectedHeadingsColor,
          }">
          5
        </div>
      </section>
  
      <section
        id="page_6"
        class="page theme-page-TraditionalStyle"
        :style="{
          backgroundColor: selectedBackgroundColor,
          fontFamily: selectedFontFamily,
        }">
        <div class="">
          <div class="">
            <h2
              class="HeaderContent"
              :style="{
                color: selectedHeadingsColor,
              }">
              Current Programs
            </h2>
            <div v-for="program in caseStatement?.core_programs" :key="program.id" class="mb-4">
              <h4 
                class="BodyContent text-bold mb-0 edit-content hover:!dashed-border cursor-pointer"
                :style="{
                  color: selectedBodyTextColor,
                  marginBottom: '8px',
                }">
                {{ program.program_name }}
              </h4>
              <div
                class="pre-text text-small edit-content hover:!dashed-border cursor-pointer"
                :style="{
                  color: selectedBodyTextColor,
                  fontFamily: selectedFontFamily,
                  whiteSpace: 'pre-line'
                }"
                @click="
                  setDynamicContent(
                    program.program_description,
                    program,
                    'program_description',
                    'Current Programs',
                    85
                  )
                "
                v-html="getTheText(program.program_description, 0, 320)">
              </div>
            </div>
          </div>
          <div class="">
            <div class="page-bottom-image d-flex flex-wrap ">
              <div
                @mouseover="showDeleteIcon = true"
                @mouseleave="showDeleteIcon = false"
                class="relative ">
                <img
                  class="hover:p-0.5 hover:!dashed-border cursor-pointer h-1"
                  :src="getImg(8) ? getImg(8).image : logos[8]"
                  @click="openFileInput('fileInput9')"
                  alt="" />
                <p
                  class="absolute top-2 right-2 text-2xl cursor-pointer bg-white rounded-full"
                  style="padding: 6px"
                  @click="deleteImage(getImg(8).id)"
                  v-if="showDeleteIcon && getImg(8).id">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="12"
                    viewBox="0 0 100 100">
                    <line
                      x1="10"
                      y1="10"
                      x2="90"
                      y2="90"
                      stroke="red"
                      stroke-width="10" />
                    <line
                      x1="10"
                      y1="90"
                      x2="90"
                      y2="10"
                      stroke="red"
                      stroke-width="10" />
                  </svg>
                </p>
                <p
                  v-if="showDeleteIcon"
                  class="absolute top-2 cursor-pointer bg-white rounded-full left-2"
                  style="padding: 3px"
                  @click="
                    openCropModel(getImg(8) ? getImg(8).image : logos[8], 9)
                  ">
                  <svg
                    height="17"
                    viewBox="0 0 48 48"
                    width="19"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="black">
                    <path d="M0 0h48v48h-48z" fill="none" />
                    <path
                      d="M34 30h4v-16c0-2.21-1.79-4-4-4h-16v4h16v16zm-20 4v-32h-4v8h-8v4h8v20c0 2.21 1.79 4 4 4h20v8h4v-8h8v-4h-32z" />
                  </svg>
                </p>
                <input
                  id="fileInput9"
                  class="fileInput-hidden"
                  type="file"
                  name="file"
                  aria-invalid="false"
                  accept="image/png, image/jpeg, image/jpg"
                  @change="(event) => updateLogo(9, event)" />
              </div>
              <div
                @mouseover="showDeleteIcon = true"
                @mouseleave="showDeleteIcon = false"
                class="relative ">
                <img
                  class="hover:p-0.5 hover:!dashed-border cursor-pointer h-1"
                  :src="getImg(9) ? getImg(9).image : logos[9]"
                  @click="openFileInput('fileInput10')"
                  alt="" />
                <p
                  class="absolute top-2 right-2 text-2xl cursor-pointer bg-white rounded-full"
                  style="padding: 6px"
                  @click="deleteImage(getImg(9).id)"
                  v-if="showDeleteIcon && getImg(9).id">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="12"
                    viewBox="0 0 100 100">
                    <line
                      x1="10"
                      y1="10"
                      x2="90"
                      y2="90"
                      stroke="red"
                      stroke-width="10" />
                    <line
                      x1="10"
                      y1="90"
                      x2="90"
                      y2="10"
                      stroke="red"
                      stroke-width="10" />
                  </svg>
                </p>
                <p
                  v-if="showDeleteIcon"
                  class="absolute top-2 cursor-pointer bg-white rounded-full left-2"
                  style="padding: 3px"
                  @click="
                    openCropModel(getImg(9) ? getImg(9).image : logos[9], 10)
                  ">
                  <svg
                    height="17"
                    viewBox="0 0 48 48"
                    width="19"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="black">
                    <path d="M0 0h48v48h-48z" fill="none" />
                    <path
                      d="M34 30h4v-16c0-2.21-1.79-4-4-4h-16v4h16v16zm-20 4v-32h-4v8h-8v4h8v20c0 2.21 1.79 4 4 4h20v8h4v-8h8v-4h-32z" />
                  </svg>
                </p>
                <input
                  id="fileInput10"
                  class="fileInput-hidden"
                  type="file"
                  name="file"
                  aria-invalid="false"
                  accept="image/png, image/jpeg, image/jpg"
                  @change="(event) => updateLogo(10, event)" />
              </div>
              <div
                @mouseover="showDeleteIcon = true"
                @mouseleave="showDeleteIcon = false"
                class="relative ">
                <img
                  class="hover:p-0.5 hover:!dashed-border cursor-pointer h-1"
                  :src="getImg(10) ? getImg(10).image : logos[10]"
                  @click="openFileInput('fileInput11')"
                  alt="" />
                <p
                  class="absolute top-2 right-2 text-2xl cursor-pointer bg-white rounded-full"
                  style="padding: 6px"
                  @click="deleteImage(getImg(10).id)"
                  v-if="showDeleteIcon && getImg(10).id">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="12"
                    viewBox="0 0 100 100">
                    <line
                      x1="10"
                      y1="10"
                      x2="90"
                      y2="90"
                      stroke="red"
                      stroke-width="10" />
                    <line
                      x1="10"
                      y1="90"
                      x2="90"
                      y2="10"
                      stroke="red"
                      stroke-width="10" />
                  </svg>
                </p>
                <p
                  v-if="showDeleteIcon"
                  class="absolute top-2 cursor-pointer bg-white rounded-full left-2"
                  style="padding: 3px"
                  @click="
                    openCropModel(getImg(10) ? getImg(10).image : logos[10], 11)
                  ">
                  <svg
                    height="17"
                    viewBox="0 0 48 48"
                    width="19"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="black">
                    <path d="M0 0h48v48h-48z" fill="none" />
                    <path
                      d="M34 30h4v-16c0-2.21-1.79-4-4-4h-16v4h16v16zm-20 4v-32h-4v8h-8v4h8v20c0 2.21 1.79 4 4 4h20v8h4v-8h8v-4h-32z" />
                  </svg>
                </p>
                <input
                  id="fileInput11"
                  class="fileInput-hidden"
                  type="file"
                  name="file"
                  aria-invalid="false"
                  accept="image/png, image/jpeg, image/jpg"
                  @change="(event) => updateLogo(11, event)" />
              </div>
  
              <div
                @mouseover="showDeleteIcon = true"
                @mouseleave="showDeleteIcon = false"
                class="relative ">
                <img
                  class="hover:p-0.5 hover:!dashed-border cursor-pointer h-1"
                  :src="getImg(11) ? getImg(11).image : logos[11]"
                  @click="openFileInput('fileInput12')"
                  alt="" />
  
                <p
                  class="absolute top-2 right-2 text-2xl cursor-pointer bg-white rounded-full"
                  style="padding: 6px"
                  @click="deleteImage(getImg(11).id)"
                  v-if="showDeleteIcon && getImg(11).id">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="12"
                    viewBox="0 0 100 100">
                    <line
                      x1="10"
                      y1="10"
                      x2="90"
                      y2="90"
                      stroke="red"
                      stroke-width="10" />
                    <line
                      x1="10"
                      y1="90"
                      x2="90"
                      y2="10"
                      stroke="red"
                      stroke-width="10" />
                  </svg>
                </p>
                <p
                  v-if="showDeleteIcon"
                  class="absolute top-2 cursor-pointer bg-white rounded-full left-2"
                  style="padding: 3px"
                  @click="
                    openCropModel(getImg(11) ? getImg(11).image : logos[11], 12)
                  ">
                  <svg
                    height="17"
                    viewBox="0 0 48 48"
                    width="19"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="black">
                    <path d="M0 0h48v48h-48z" fill="none" />
                    <path
                      d="M34 30h4v-16c0-2.21-1.79-4-4-4h-16v4h16v16zm-20 4v-32h-4v8h-8v4h8v20c0 2.21 1.79 4 4 4h20v8h4v-8h8v-4h-32z" />
                  </svg>
                </p>
  
                <input
                  id="fileInput12"
                  class="fileInput-hidden"
                  type="file"
                  name="file"
                  aria-invalid="false"
                  accept="image/png, image/jpeg, image/jpg"
                  @change="(event) => updateLogo(12, event)" />
              </div>
            </div>
          </div>
        </div>
        <div
          class="page-num-i"
          :style="{
            borderColor: selectedHeadingsColor,
            color: selectedHeadingsColor,
          }">
          {{ 6 }}
        </div>
      </section>
  
      <section
        id="page_7"
        class="page theme-page-TraditionalStyle"
        :style="{
          backgroundColor: selectedBackgroundColor,
          fontFamily: selectedFontFamily,
        }"
        v-if="caseStatement?.case_statement_summary?.split(' ')?.length > 320">
        <div>
          <div class=" edit-content hover:!dashed-border cursor-pointer">
            <pre
              class="pre-text text-small edit-content cursor-pointer"
              :style="{
                color: selectedBodyTextColor,
                fontFamily: selectedFontFamily,
              }"
              v-if="caseStatement?.case_statement_summary"
              v-html="
                getTheText(
                  caseStatement.case_statement_summary,
                  320,
                  625,
                  'second'
                )
              "
              @click="
                setDynamicContent(
                  caseStatement.case_statement_summary,
                  caseStatement,
                  'case_statement_summary',
                  'Current Programs',
                  625
                )
              "></pre>
          </div>
          <div>
            <div class="page-bottom-image d-flex flex-wrap ">
              <div
                @mouseover="showDeleteIcon = true"
                @mouseleave="showDeleteIcon = false"
                class="relative ">
                <img
                  class="hover:p-0.5 hover:!dashed-border cursor-pointer h-1"
                  :src="getImg(12) ? getImg(12).image : logos[12]"
                  @click="openFileInput('fileInput13')"
                  alt="" />
                <p
                  class="absolute top-2 right-2 text-2xl cursor-pointer bg-white rounded-full"
                  style="padding: 6px"
                  @click="deleteImage(getImg(12).id)"
                  v-if="showDeleteIcon && getImg(12).id">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="12"
                    viewBox="0 0 100 100">
                    <line
                      x1="10"
                      y1="10"
                      x2="90"
                      y2="90"
                      stroke="red"
                      stroke-width="10" />
                    <line
                      x1="10"
                      y1="90"
                      x2="90"
                      y2="10"
                      stroke="red"
                      stroke-width="10" />
                  </svg>
                </p>
                <p
                  v-if="showDeleteIcon"
                  class="absolute top-2 cursor-pointer bg-white rounded-full left-2"
                  style="padding: 3px"
                  @click="
                    openCropModel(getImg(12) ? getImg(12).image : logos[12], 13)
                  ">
                  <svg
                    height="17"
                    viewBox="0 0 48 48"
                    width="19"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="black">
                    <path d="M0 0h48v48h-48z" fill="none" />
                    <path
                      d="M34 30h4v-16c0-2.21-1.79-4-4-4h-16v4h16v16zm-20 4v-32h-4v8h-8v4h8v20c0 2.21 1.79 4 4 4h20v8h4v-8h8v-4h-32z" />
                  </svg>
                </p>
                <input
                  id="fileInput13"
                  class="fileInput-hidden"
                  type="file"
                  name="file"
                  aria-invalid="false"
                  accept="image/png, image/jpeg, image/jpg"
                  @change="(event) => updateLogo(13, event)" />
              </div>
              <div
                @mouseover="showDeleteIcon = true"
                @mouseleave="showDeleteIcon = false"
                class="relative ">
                <img
                  class="hover:p-0.5 hover:!dashed-border cursor-pointer h-1"
                  :src="getImg(13) ? getImg(13) : logos[13]"
                  @click="openFileInput('fileInput14')"
                  alt="" />
                <p
                  class="absolute top-2 right-2 text-2xl cursor-pointer bg-white rounded-full"
                  style="padding: 6px"
                  @click="deleteImage(getImg(13).id)"
                  v-if="showDeleteIcon && getImg(13).id">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="12"
                    viewBox="0 0 100 100">
                    <line
                      x1="10"
                      y1="10"
                      x2="90"
                      y2="90"
                      stroke="red"
                      stroke-width="10" />
                    <line
                      x1="10"
                      y1="90"
                      x2="90"
                      y2="10"
                      stroke="red"
                      stroke-width="10" />
                  </svg>
                </p>
                <p
                  v-if="showDeleteIcon"
                  class="absolute top-2 cursor-pointer bg-white rounded-full left-2"
                  style="padding: 3px"
                  @click="
                    openCropModel(getImg(13) ? getImg(13).image : logos[13], 14)
                  ">
                  <svg
                    height="17"
                    viewBox="0 0 48 48"
                    width="19"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="black">
                    <path d="M0 0h48v48h-48z" fill="none" />
                    <path
                      d="M34 30h4v-16c0-2.21-1.79-4-4-4h-16v4h16v16zm-20 4v-32h-4v8h-8v4h8v20c0 2.21 1.79 4 4 4h20v8h4v-8h8v-4h-32z" />
                  </svg>
                </p>
                <input
                  id="fileInput14"
                  class="fileInput-hidden"
                  type="file"
                  name="file"
                  aria-invalid="false"
                  accept="image/png, image/jpeg, image/jpg"
                  @change="(event) => updateLogo(14, event)" />
              </div>
              <div
                @mouseover="showDeleteIcon = true"
                @mouseleave="showDeleteIcon = false"
                class="relative ">
                <img
                  class="hover:p-0.5 hover:!dashed-border cursor-pointer h-1"
                  :src="getImg(14) ? getImg(14).image : logos[14]"
                  @click="openFileInput('fileInput15')"
                  alt="" />
                <p
                  class="absolute top-2 right-2 text-2xl cursor-pointer bg-white rounded-full"
                  style="padding: 6px"
                  @click="deleteImage(getImg(14).id)"
                  v-if="showDeleteIcon && getImg(14).id">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="12"
                    viewBox="0 0 100 100">
                    <line
                      x1="10"
                      y1="10"
                      x2="90"
                      y2="90"
                      stroke="red"
                      stroke-width="10" />
                    <line
                      x1="10"
                      y1="90"
                      x2="90"
                      y2="10"
                      stroke="red"
                      stroke-width="10" />
                  </svg>
                </p>
                <p
                  v-if="showDeleteIcon"
                  class="absolute top-2 cursor-pointer bg-white rounded-full left-2"
                  style="padding: 3px"
                  @click="
                    openCropModel(getImg(14) ? getImg(14).image : logos[14], 15)
                  ">
                  <svg
                    height="17"
                    viewBox="0 0 48 48"
                    width="19"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="black">
                    <path d="M0 0h48v48h-48z" fill="none" />
                    <path
                      d="M34 30h4v-16c0-2.21-1.79-4-4-4h-16v4h16v16zm-20 4v-32h-4v8h-8v4h8v20c0 2.21 1.79 4 4 4h20v8h4v-8h8v-4h-32z" />
                  </svg>
                </p>
                <input
                  id="fileInput15"
                  class="fileInput-hidden"
                  type="file"
                  name="file"
                  aria-invalid="false"
                  accept="image/png, image/jpeg, image/jpg"
                  @change="(event) => updateLogo(15, event)" />
              </div>
  
              <div
                @mouseover="showDeleteIcon = true"
                @mouseleave="showDeleteIcon = false"
                class="relative ">
                <img
                  class="hover:p-0.5 hover:!dashed-border-border cursor-pointer h-1"
                  :src="getImg(15) ? getImg(15) : logos[15]"
                  @click="openFileInput('fileInput16')"
                  alt="" />
                <p
                  class="absolute top-2 right-2 text-2xl cursor-pointer bg-white rounded-full"
                  style="padding: 6px"
                  @click="deleteImage(getImg(15).id)"
                  v-if="showDeleteIcon && getImg(15).id">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="12"
                    viewBox="0 0 100 100">
                    <line
                      x1="10"
                      y1="10"
                      x2="90"
                      y2="90"
                      stroke="red"
                      stroke-width="10" />
                    <line
                      x1="10"
                      y1="90"
                      x2="90"
                      y2="10"
                      stroke="red"
                      stroke-width="10" />
                  </svg>
                </p>
                <p
                  v-if="showDeleteIcon"
                  class="absolute top-2 cursor-pointer bg-white rounded-full left-2"
                  style="padding: 3px"
                  @click="
                    openCropModel(getImg(15) ? getImg(15).image : logos[15], 16)
                  ">
                  <svg
                    height="17"
                    viewBox="0 0 48 48"
                    width="19"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="black">
                    <path d="M0 0h48v48h-48z" fill="none" />
                    <path
                      d="M34 30h4v-16c0-2.21-1.79-4-4-4h-16v4h16v16zm-20 4v-32h-4v8h-8v4h8v20c0 2.21 1.79 4 4 4h20v8h4v-8h8v-4h-32z" />
                  </svg>
                </p>
                <input
                  id="fileInput16"
                  class="fileInput-hidden"
                  type="file"
                  name="file"
                  aria-invalid="false"
                  accept="image/png, image/jpeg, image/jpg"
                  @change="(event) => updateLogo(16, event)" />
              </div>
            </div>
          </div>
        </div>
        <div
          class="page-num-i"
          :style="{
            borderColor: selectedHeadingsColor,
            color: selectedHeadingsColor,
          }">
          {{ 7 }}
        </div>
      </section>
  
      <section
        id="page_9"
        class="page letter-page theme-page-TraditionalStyle"
        :style="{
          backgroundColor: selectedBackgroundColor,
          fontFamily: selectedFontFamily,
        }">
        <div
          @mouseover="showDeleteIcon = true"
          @mouseleave="showDeleteIcon = false"
          class="relative">
          <img
            class="hover:p-0.5 hover:!dashed-border cursor-pointer"
            :src="getImg(16) ? getImg(16).image : logos[16]"
            @click="openFileInput('fileInput17')"
            alt="" />
          <p
            class="absolute top-2 right-2 text-2xl cursor-pointer bg-white rounded-full"
            style="padding: 6px"
            @click="deleteImage(getImg(16).id)"
            v-if="showDeleteIcon && getImg(16).id">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="12"
              viewBox="0 0 100 100">
              <line
                x1="10"
                y1="10"
                x2="90"
                y2="90"
                stroke="red"
                stroke-width="10" />
              <line
                x1="10"
                y1="90"
                x2="90"
                y2="10"
                stroke="red"
                stroke-width="10" />
            </svg>
          </p>
          <p
            v-if="showDeleteIcon"
            class="absolute top-2 cursor-pointer bg-white rounded-full left-2"
            style="padding: 3px"
            @click="openCropModel(getImg(16) ? getImg(16).image : logos[16], 17)">
            <svg
              height="17"
              viewBox="0 0 48 48"
              width="19"
              xmlns="http://www.w3.org/2000/svg"
              fill="black">
              <path d="M0 0h48v48h-48z" fill="none" />
              <path
                d="M34 30h4v-16c0-2.21-1.79-4-4-4h-16v4h16v16zm-20 4v-32h-4v8h-8v4h8v20c0 2.21 1.79 4 4 4h20v8h4v-8h8v-4h-32z" />
            </svg>
          </p>
          <input
            id="fileInput17"
            class="fileInput-hidden"
            type="file"
            name="file"
            aria-invalid="false"
            accept="image/png, image/jpeg, image/jpg"
            @change="(event) => updateLogo(17, event)" />
        </div>
        <h2
          class="HeaderContent mb-0"
          :style="{
            color: selectedHeadingsColor,
            marginBottom: '8px',
            marginTop: '0',
          }">
          Call for More
        </h2>
        <div class="w-full edit-content hover:!dashed-border cursor-pointer">
          <p
            class="BodyContent text-small"
            :style="{
              color: selectedBodyTextColor,
            }"
            @click="
              setDynamicContent(
                caseStatement.call_for_more,
                caseStatement,
                'call_for_more',
                'Call For More',
                285
              )
            "
            v-html="
              caseStatement?.call_for_more
                ?.replace(/\n/g, '<br>')
                .split(/\s+/)
                .join(' ')
            "></p>
        </div>
        <div
          class="page-num"
          :style="{
            borderColor: selectedHeadingsColor,
            color: selectedHeadingsColor,
          }">
          {{
            caseStatement?.case_statement_summary?.split(" ")?.length > 320
              ? 8
              : 7
          }}
        </div>
      </section>
      <section
        id="page_10"
        class="page letter-page theme-page-TraditionalStyle"
        :style="{
          backgroundColor: selectedBackgroundColor,
          fontFamily: selectedFontFamily,
        }">
        <h3
          class="HeaderContent mb-0"
          :style="{
            color: selectedHeadingsColor,
          }"
          v-html="
            `${organization.name} has a 3-year fundraising goal of ${(
              organization.total_fundraising_goal_3y - 0
            ).toLocaleString()}
          over a 3-year period.`
          "></h3>
        <div class="w-full">
          <h3
            class="BodyContent text-bold"
            :style="{
              color: selectedBodyTextColor,
            }">
            Below is a breakdown of our goal:
          </h3>
          <table
            class="w-1 breakdown-table mt-3 edit-content hover:!dashed-border cursor-pointer"
            @click="redirectTo('funding-new-projects-new-projects')">
            <tbody>
              <tr
                v-for="(project, index) in caseStatement?.projects"
                :key="index">
                <td
                  :style="{
                    borderColor: selectedHeadingsColor,
                  }">
                  <p
                    class="BodyContent"
                    :style="{
                      color: selectedBodyTextColor,
                    }">
                    {{ project.project_name }}
                  </p>
                </td>
                <td
                  :style="{
                    borderColor: selectedHeadingsColor,
                  }">
                  <p
                    :style="{
                      color: selectedBodyTextColor,
                      'font-weight': 'bold',
                    }">
                    ${{ project.project_cost.toLocaleString() }}
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="page-num"
          :style="{
            borderColor: selectedHeadingsColor,
            color: selectedHeadingsColor,
          }">
          {{
            caseStatement?.case_statement_summary?.split(" ")?.length > 320
              ? 9
              : 8
          }}
        </div>
      </section>
  
      <section
        id="page_11"
        class="page theme-page-TraditionalStyle"
        :style="{
          backgroundColor: selectedBackgroundColor,
          fontFamily: selectedFontFamily,
        }">
        <h2
          class="HeaderContent mb-0"
          :style="{
            color: selectedHeadingsColor,
            fontFamily: selectedFontFamily,
          }"
          v-html="`${organization?.name} Funding Priorities`"></h2>
          <div v-for="(project, idx) in caseStatement.projects" :key="idx">
            <div v-if="idx == 0">
              <div :style="{ display: 'flex', flexWrap: 'wrap', paddingTop: '7px' }">
                <h5
                  class="HeaderContent text-bold mb-0 edit-content hover:!dashed-border cursor-pointer"
                  :style="{
                    color: selectedBodyTextColor,
                    fontFamily: selectedFontFamily,
                    marginRight: '7px',
                  }"
                  @click="
                    setDynamicContent(
                      caseStatement.projects[idx].project_name,
                      caseStatement.projects[idx],
                      'project_name',
                      `Funding Priorities project  ${idx+1} Heading`,
                    )
                  "
                  > Annual Operations </h5>
  
                  <!-- above is the Annual Operations in place of annual programs -->
  
                  <h5
                    class="HeaderContent text-bold mb-0 edit-content hover:!dashed-border cursor-pointer"
                    :style="{
                      color: selectedBodyTextColor,
                      fontFamily: selectedFontFamily,
                    }"
                    @click="
                      setDynamicContent(
                        caseStatement.projects[idx].project_cost,
                        caseStatement.projects[idx],
                        'project_cost',
                        `Funding Priorities project  ${idx +1} cost`
                      )
                    "
                    > {{ formatToDecimal(totalExpenses - 0) }} </h5>
              </div>
  
              <p
              class="BodyContent text-small edit-content hover:!dashed-border cursor-pointer"
              :style="{
                color: selectedBodyTextColor,
              }"
              @click="
                  setDynamicContent(handleProRationaleGoal(project.all_questions_answers),
                  returnProRationaleGoal(project.all_questions_answers),
                    'question_answer',
                    `Funding Priorities project ${idx+1}`,
                    85
                  )
                "
              v-html="handleProRationaleGoal(project.all_questions_answers)">
            </p>
            </div>
          </div>
        <!-- <div>
          <h5
            :style="{
              fontFamily: selectedFontFamily,
              color: selectedBodyTextColor,
            }">
            ANNUAL OPERATIONS:
            {{
              formatToDecimal(caseStatement?.totals?.annual_fundraising_goal || 0)
            }}
          </h5>
        </div> -->
  
        <div class="d-flex pb-1 crt-container">
          <div
            class="w-2 hover:!dashed-border ">
            <h4
              class="HeaderContent mb-0 text-center"
              :style="{
                color: selectedHeadingsColor,
                fontFamily: selectedFontFamily,
              }">
              Projected Expenses
            </h4>
            <div class="d-flex align-center j-center text-center">
              <ExpensesChart
                :selectedBodyTextColor="selectedBodyTextColor"
                :selectedHeadingsColor="selectedHeadingsColor"
                :selectedFontFamily="selectedFontFamily"
                :expensesData="caseStatement?.expenses" />
            </div>
          </div>
  
          <div
            class="w-2 hover:!dashed-border">
            <h4
              class="HeaderContent mb-0 text-center"
              :style="{
                color: selectedHeadingsColor,
                fontFamily: selectedFontFamily,
              }">
              Projected Revenues
            </h4>
            <div class="d-flex align-center j-center text-center">
              <RevenuesChart
                :selectedBodyTextColor="selectedBodyTextColor"
                :selectedHeadingsColor="selectedHeadingsColor"
                :selectedFontFamily="selectedFontFamily"
                :revenuesData="caseStatement?.revenues" />
            </div>
          </div>
        </div>
  
        <div
          class="page-num"
          :style="{
            borderColor: selectedHeadingsColor,
            color: selectedHeadingsColor,
          }">
          {{
            caseStatement?.case_statement_summary?.split(" ")?.length > 320
              ? 10
              : 9
          }}
        </div>
      </section>
  
      <section
        id="page_13"
        class="page priorities-page theme-page-TraditionalStyle"
        :style="{
          backgroundColor: selectedBackgroundColor,
          fontFamily: selectedFontFamily,
        }"
        v-if="caseStatement.projects?.length > 1">
        <h2
          class="HeaderContent mb-0"
          :style="{
            color: selectedHeadingsColor,
          }">
          {{ caseStatement?.organization_name }} Funding Priorities
        </h2>
        <div v-for="(project, idx) in caseStatement.projects" :key="idx">
          <div v-if="idx > 0 && idx < 3">
            <div :style="{ display: 'flex', flexWrap: 'wrap', paddingTop: '7px' }">
              <h5
                class="HeaderContent text-bold mb-0 edit-content hover:!dashed-border cursor-pointer"
                :style="{
                  color: selectedBodyTextColor,
                  fontFamily: selectedFontFamily,
                  marginRight: '7px',
                }"
                @click="
                  setDynamicContent(
                    caseStatement.projects[idx].project_name,
                    caseStatement.projects[idx],
                    'project_name',
                    `Funding Priorities project  ${idx+1} Heading`
                  )
                "
                v-html="project.project_name"></h5>
  
              <h5
                class="HeaderContent text-bold mb-0 edit-content hover:!dashed-border cursor-pointer"
                :style="{
                  color: selectedBodyTextColor,
                  fontFamily: selectedFontFamily,
                }"
                @click="
                  setDynamicContent(
                    caseStatement.projects[idx].project_cost,
                    caseStatement.projects[idx],
                    'project_cost',
                    `Funding Priorities project  ${idx+1} cost`
                  )
                "
                v-html="handleProCost(project.project_cost)"></h5>
            </div>
            <p
              class="BodyContent text-small edit-content hover:!dashed-border cursor-pointer"
              :style="{
                color: selectedBodyTextColor,
              }"
              @click="
                  setDynamicContent(handleProRationaleGoal(project.all_questions_answers),
                  returnProRationaleGoal(project.all_questions_answers),
                    'question_answer',
                    `Funding Priorities project ${idx+1}`,
                    85
                  )
                "
              v-html="handleProRationaleGoal(project.all_questions_answers)">
            </p>
          </div>
        </div>
  
        <div
          class="page-num"
          :style="{
            borderColor: selectedHeadingsColor,
            color: selectedHeadingsColor,
          }">
          {{
            caseStatement?.case_statement_summary?.split(" ")?.length > 320
              ? 11
              : 10
          }}
        </div>
      </section>
  
      <section
        id="page_14"
        class="page priorities-page theme-page-TraditionalStyle"
        :style="{
          backgroundColor: selectedBackgroundColor,
          fontFamily: selectedFontFamily,
        }"
        v-if="caseStatement.projects?.length > 3">
        <h2
          class="HeaderContent mb-0"
          :style="{
            color: selectedHeadingsColor,
          }">
          {{ caseStatement?.organization_name }} Funding Priorities
        </h2>
        <div v-for="(project, idx) in caseStatement.projects" :key="idx">
          <div v-if="idx > 2 && idx < 5">
            <div :style="{ display: 'flex', flexWrap: 'wrap', paddingTop: '7px' }">
              <h5
                class="HeaderContent text-bold mb-0 edit-content hover:!dashed-border cursor-pointer"
                :style="{
                  color: selectedBodyTextColor,
                  fontFamily: selectedFontFamily,
                  marginRight: '7px',
                }"
                @click="
                  setDynamicContent(
                    caseStatement.projects[idx].project_name,
                    caseStatement.projects[idx],
                    'project_name',
                    `Funding Priorities project  ${idx+1} Heading`
                  )
                "
                v-html="project.project_name"></h5>
  
              <h5
                class="HeaderContent text-bold mb-0 edit-content hover:!dashed-border cursor-pointer"
                :style="{
                  color: selectedBodyTextColor,
                  fontFamily: selectedFontFamily,
                }"
                @click="
                  setDynamicContent(
                    caseStatement.projects[idx].project_cost,
                    caseStatement.projects[idx],
                    'project_cost',
                    `Funding Priorities project  ${idx+1} cost`
                  )
                "
                v-html="handleProCost(project.project_cost)"></h5>
            </div>
            <p
              class="BodyContent text-small edit-content hover:!dashed-border cursor-pointer"
              :style="{
                color: selectedBodyTextColor,
              }"
              @click="
                  setDynamicContent(handleProRationaleGoal(project.all_questions_answers),
                  returnProRationaleGoal(project.all_questions_answers),
                    'question_answer',
                    `Funding Priorities project ${idx+1}`
                  )
                "
              v-html="handleProRationaleGoal(project.all_questions_answers)">
            </p>
          </div>
        </div>
  
        <div
          class="page-num"
          :style="{
            borderColor: selectedHeadingsColor,
            color: selectedHeadingsColor,
          }">
          {{
            caseStatement?.case_statement_summary?.split(" ")?.length > 320
              ? 12
              : 11
          }}
        </div>
      </section>
  
      <section id="page_15" class="relative p-0 theme-page-TraditionalStyle">
        <div
          class="page h-1 w-1 d-flex flex-wrap"
          :style="{
            backgroundColor: selectedBackgroundColor,
            fontFamily: selectedFontFamily,
          }">
          <div class="w-2 h-2 d-flex align-center j-center">
            <div class="">
              <h1
                class="HeaderContent"
                :style="{
                  color: selectedHeadingsColor,
                }">
                Success Stories
              </h1>
            </div>
          </div>
          <div class="w-2 h-2">
            <div
              @mouseover="showDeleteIcon = true"
              @mouseleave="showDeleteIcon = false"
              class="relative h-1 success-stories-img">
              <img
                class="hover:p-0.5 hover:!dashed-border cursor-pointer"
                :src="getImg(18) ? getImg(18).image : logos[18]"
                @click="openFileInput('fileInput19')"
                alt="" />
              <p
                class="absolute top-2 right-2 text-2xl cursor-pointer bg-white rounded-full"
                style="padding: 6px"
                @click="deleteImage(getImg(18).id)"
                v-if="showDeleteIcon && getImg(18).id">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="12"
                  viewBox="0 0 100 100">
                  <line
                    x1="10"
                    y1="10"
                    x2="90"
                    y2="90"
                    stroke="red"
                    stroke-width="10" />
                  <line
                    x1="10"
                    y1="90"
                    x2="90"
                    y2="10"
                    stroke="red"
                    stroke-width="10" />
                </svg>
              </p>
              <p
                v-if="showDeleteIcon"
                class="absolute top-2 cursor-pointer bg-white rounded-full left-2"
                style="padding: 3px"
                @click="
                  openCropModel(getImg(18) ? getImg(18).image : logos[18], 19)
                ">
                <svg
                  height="17"
                  viewBox="0 0 48 48"
                  width="19"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="black">
                  <path d="M0 0h48v48h-48z" fill="none" />
                  <path
                    d="M34 30h4v-16c0-2.21-1.79-4-4-4h-16v4h16v16zm-20 4v-32h-4v8h-8v4h8v20c0 2.21 1.79 4 4 4h20v8h4v-8h8v-4h-32z" />
                </svg>
              </p>
              <input
                id="fileInput19"
                class="fileInput-hidden"
                type="file"
                name="file"
                aria-invalid="false"
                accept="image/png, image/jpeg, image/jpg"
                @change="(event) => updateLogo(19, event)" />
            </div>
          </div>
          <div
            class="w-full h-2"
            v-for="(story, idx) in caseStatement.success_stories"
            :key="story.id">
            <div v-if="idx == 0">
              <p
                class="BodyContent text-small edit-content hover:!dashed-border cursor-pointer"
                :style="{
                  color: selectedBodyTextColor,
                  marginTop: '-1.5rem',
                }"
                v-html="
                  story?.user_story?.replace(/\n/g, '<br>').split(/\s+/).join(' ')
                "
                @click="
                  setDynamicContent(
                    story.user_story,
                    caseStatement.success_stories[idx],
                    'user_story',
                    'Success Story 1',
                    263
                  )
                "></p>
            </div>
          </div>
        </div>
        <div
          class="page-num"
          :style="{
            fontFamily: selectedFontFamily,
            borderColor: selectedHeadingsColor,
            color: selectedHeadingsColor,
          }">
          {{
            caseStatement?.case_statement_summary?.split(" ")?.length > 320
              ? Math.floor(caseStatement.projects?.length / 2) + 1 + 10
              : Math.floor(caseStatement.projects?.length / 2) + 1 + 9
          }}
        </div>
      </section>
  
      <section
        id="page_16"
        class="relative p-0 theme-page-TraditionalStyle"
        :style="{
          backgroundColor: selectedBackgroundColor,
          fontFamily: selectedFontFamily,
        }"
        v-if="caseStatement.success_stories?.length > 1">
        <div
          class="page h-1 w-1"
          :style="{
            backgroundColor: selectedBackgroundColor,
          }">
          <div
            v-for="(story, idx) in caseStatement.success_stories"
            :key="story.id">
            <div v-if="idx > 0">
              <div class="w-full mb-8">
                <p
                  class="BodyContent text-small edit-content hover:!dashed-border cursor-pointer"
                  :style="{
                    color: selectedBodyTextColor,
                  }"
                  @click="
                    setDynamicContent(
                      story.user_story, 
                      caseStatement.success_stories[idx],
                      'user_story',
                      `Success Story ${idx + 1}`,
                      263
                    )
                  "
                  v-html="
                    story?.user_story
                      ?.replace(/\n/g, '<br>')
                      .split(/\s+/)
                      .join(' ')
                  "></p>
              </div>
            </div>
          </div>
        </div>
        <div
          class="page-num"
          :style="{
            borderColor: selectedHeadingsColor,
            color: selectedHeadingsColor,
          }">
          {{
            caseStatement?.case_statement_summary?.split(" ")?.length > 320
              ? Math.floor(caseStatement.projects?.length / 2) + 1 + 11
              : Math.floor(caseStatement.projects?.length / 2) + 1 + 10
          }}
        </div>
      </section>
  
      <section
        id="page_18"
        class="page theme-page-TraditionalStyle"
        :style="{
          backgroundColor: selectedBackgroundColor,
          fontFamily: selectedFontFamily,
        }">
        <div>
          <div>
            <h2
              class="HeaderContent m-0"
              :style="{
                color: selectedHeadingsColor,
              }">
              Join Us
            </h2>
            <p
              class="BodyContent edit-content hover:!dashed-border cursor-pointer"
              :style="{
                color: selectedBodyTextColor,
              }"
              v-html="
                caseStatement?.case_statement_join_us_message
                  ?.replace(/\n/g, '<br>')
                  .split(/\s+/)
                  .join(' ')
              "
              @click="
                setDynamicContent(
                  caseStatement.case_statement_join_us_message,
                  caseStatement,
                  'case_statement_join_us_message',
                  'Join Us',
                  138
                )
              "></p>
  
            <h2
              class="HeaderContent m-0"
              :style="{
                color: selectedHeadingsColor,
                paddingBottom: '11px'
              }">
              Ways To Give:
            </h2>
            <div
              class="list-ways d-flex flex-wrap cursor-pointer"
              :style="{
                color: selectedHeadingsColor,
              }">
              <div
                class="box w-2 pr-1"
                v-for="(item, idx) in formattedWaysToGive"
                :key="idx">
                <font-awesome-icon
                  v-if="item.icon"
                  :icon="item.icon"
                  class="ways-icon"
                  :style="{
                    color: selectedHeadingsColor,
                  }" />
                <p
                  class="BodyContent flex justify-items-center text p-px m-0 edit-content hover:!dashed-border"
                  :style="{
                    color: selectedBodyTextColor,
                  }"
                  v-html="item.label"
                  @click="
                    setDynamicContent(
                      item.label,
                      Array.isArray(caseStatement.case_statement_ways_to_give) ? caseStatement.case_statement_ways_to_give[idx] : null,
                      'label',
                      'Way To Give'
                    )
                  "></p>
              </div>
            </div>
  
            <h2
              class="HeaderContent m-0"
              :style="{
                color: selectedHeadingsColor,
              }">
              Contact Us:
            </h2>
            <div
              class="BodyContent cursor-pointer"
              :style="{
                color: selectedBodyTextColor,
              }">
              <p
                :style="{
                  color: selectedHeadingsColor,
                }"
                v-html="organization.name"
                class="edit-content hover:!dashed-border"></p>
  
              <p
                :style="{
                  color: selectedHeadingsColor,
                }"
                class="edit-content hover:!dashed-border"
                v-html="organization.director_name"
                @click="
                  setDynamicContent(
                    organization.director_name,
                    organization,
                    'director_name',
                    'Director Name'
                  )
                "></p>
  
              <p
                :style="{
                  color: selectedHeadingsColor,
                }"
                class="edit-content hover:!dashed-border"
                v-html="organization.address"
                @click="
                  setDynamicContent(
                    organization.address,
                    organization,
                    'address',
                    'Address'
                  )
                "></p>
  
              <p
                :style="{
                  color: selectedHeadingsColor,
                }"
                class="edit-content hover:!dashed-border"
                v-html="organization.phone"
                @click="
                  setDynamicContent(
                    organization.phone,
                    organization,
                    'phone',
                    'Phone'
                  )
                "></p>
  
              <p
                :style="{
                  color: selectedHeadingsColor,
                }"
                class="edit-content hover:!dashed-border"
                v-html="organization.website"
                @click="
                  setDynamicContent(
                    organization.website,
                    organization,
                    'website',
                    'Website'
                  )
                "></p>
            </div>
          </div>
          <div>
            <div class="page-bottom-image d-flex flex-wrap ">
              <div
                @mouseover="showDeleteIcon = true"
                @mouseleave="showDeleteIcon = false"
                class="relative ">
                <img
                  class="hover:p-0.5 hover:!dashed-border cursor-pointer h-1 w-1"
                  :src="getImg(19) ? getImg(19).image : logos[19]"
                  @click="openFileInput('fileInput20')"
                  alt="" />
                <p
                  class="absolute top-2 right-2 text-2xl cursor-pointer bg-white rounded-full"
                  style="padding: 6px"
                  @click="deleteImage(getImg(19).id)"
                  v-if="showDeleteIcon && getImg(19).id">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="12"
                    viewBox="0 0 100 100">
                    <line
                      x1="10"
                      y1="10"
                      x2="90"
                      y2="90"
                      stroke="red"
                      stroke-width="10" />
                    <line
                      x1="10"
                      y1="90"
                      x2="90"
                      y2="10"
                      stroke="red"
                      stroke-width="10" />
                  </svg>
                </p>
                <p
                  v-if="showDeleteIcon"
                  class="absolute top-2 cursor-pointer bg-white rounded-full left-2"
                  style="padding: 3px"
                  @click="
                    openCropModel(getImg(19) ? getImg(19).image : logos[19], 20)
                  ">
                  <svg
                    height="17"
                    viewBox="0 0 48 48"
                    width="19"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="black">
                    <path d="M0 0h48v48h-48z" fill="none" />
                    <path
                      d="M34 30h4v-16c0-2.21-1.79-4-4-4h-16v4h16v16zm-20 4v-32h-4v8h-8v4h8v20c0 2.21 1.79 4 4 4h20v8h4v-8h8v-4h-32z" />
                  </svg>
                </p>
  
                <input
                  id="fileInput20"
                  class="fileInput-hidden"
                  type="file"
                  name="file"
                  aria-invalid="false"
                  accept="image/png, image/jpeg, image/jpg"
                  @change="(event) => updateLogo(20, event)" />
              </div>
  
              <div
                @mouseover="showDeleteIcon = true"
                @mouseleave="showDeleteIcon = false"
                class="relative ">
                <img
                  class="hover:p-0.5 hover:!dashed-border cursor-pointer h-1 w-1"
                  :src="getImg(20) ? getImg(20).image : logos[20]"
                  @click="openFileInput('fileInput21')"
                  alt="" />
                <p
                  class="absolute top-2 right-2 text-2xl cursor-pointer bg-white rounded-full"
                  style="padding: 6px"
                  @click="deleteImage(getImg(20).id)"
                  v-if="showDeleteIcon && getImg(20).id">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="12"
                    viewBox="0 0 100 100">
                    <line
                      x1="10"
                      y1="10"
                      x2="90"
                      y2="90"
                      stroke="red"
                      stroke-width="10" />
                    <line
                      x1="10"
                      y1="90"
                      x2="90"
                      y2="10"
                      stroke="red"
                      stroke-width="10" />
                  </svg>
                </p>
                <p
                  v-if="showDeleteIcon"
                  class="absolute top-2 cursor-pointer bg-white rounded-full left-2"
                  style="padding: 3px"
                  @click="
                    openCropModel(getImg(20) ? getImg(20).image : logos[20], 21)
                  ">
                  <svg
                    height="17"
                    viewBox="0 0 48 48"
                    width="19"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="black">
                    <path d="M0 0h48v48h-48z" fill="none" />
                    <path
                      d="M34 30h4v-16c0-2.21-1.79-4-4-4h-16v4h16v16zm-20 4v-32h-4v8h-8v4h8v20c0 2.21 1.79 4 4 4h20v8h4v-8h8v-4h-32z" />
                  </svg>
                </p>
                <input
                  id="fileInput21"
                  class="fileInput-hidden"
                  type="file"
                  name="file"
                  aria-invalid="false"
                  accept="image/png, image/jpeg, image/jpg"
                  @change="(event) => updateLogo(21, event)" />
              </div>
  
              <div
                @mouseover="showDeleteIcon = true"
                @mouseleave="showDeleteIcon = false"
                class="relative ">
                <img
                  class="hover:p-0.5 hover:!dashed-border cursor-pointer h-1 w-1"
                  :src="getImg(21) ? getImg(21).image : logos[21]"
                  @click="openFileInput('fileInput22')"
                  alt="" />
                <p
                  class="absolute top-2 right-2 text-2xl cursor-pointer bg-white rounded-full"
                  style="padding: 6px"
                  @click="deleteImage(getImg(21).id)"
                  v-if="showDeleteIcon && getImg(21).id">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="12"
                    viewBox="0 0 100 100">
                    <line
                      x1="10"
                      y1="10"
                      x2="90"
                      y2="90"
                      stroke="red"
                      stroke-width="10" />
                    <line
                      x1="10"
                      y1="90"
                      x2="90"
                      y2="10"
                      stroke="red"
                      stroke-width="10" />
                  </svg>
                </p>
                <p
                  v-if="showDeleteIcon"
                  class="absolute top-2 cursor-pointer bg-white rounded-full left-2"
                  style="padding: 3px"
                  @click="
                    openCropModel(getImg(21) ? getImg(21).image : logos[21], 22)
                  ">
                  <svg
                    height="17"
                    viewBox="0 0 48 48"
                    width="19"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="black">
                    <path d="M0 0h48v48h-48z" fill="none" />
                    <path
                      d="M34 30h4v-16c0-2.21-1.79-4-4-4h-16v4h16v16zm-20 4v-32h-4v8h-8v4h8v20c0 2.21 1.79 4 4 4h20v8h4v-8h8v-4h-32z" />
                  </svg>
                </p>
                <input
                  id="fileInput22"
                  class="fileInput-hidden"
                  type="file"
                  name="file"
                  aria-invalid="false"
                  accept="image/png, image/jpeg, image/jpg"
                  @change="(event) => updateLogo(22, event)" />
              </div>
  
              <div
                @mouseover="showDeleteIcon = true"
                @mouseleave="showDeleteIcon = false"
                class="relative ">
                <img
                  class="hover:p-0.5 hover:!dashed-border cursor-pointer h-1 w-1"
                  :src="getImg(22) ? getImg(22).image : logos[22]"
                  @click="openFileInput('fileInput23')"
                  alt="" />
                <p
                  class="absolute top-2 right-2 text-2xl cursor-pointer bg-white rounded-full"
                  style="padding: 6px"
                  @click="deleteImage(getImg(22).id)"
                  v-if="showDeleteIcon && getImg(22).id">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="12"
                    viewBox="0 0 100 100">
                    <line
                      x1="10"
                      y1="10"
                      x2="90"
                      y2="90"
                      stroke="red"
                      stroke-width="10" />
                    <line
                      x1="10"
                      y1="90"
                      x2="90"
                      y2="10"
                      stroke="red"
                      stroke-width="10" />
                  </svg>
                </p>
                <p
                  v-if="showDeleteIcon"
                  class="absolute top-2 cursor-pointer bg-white rounded-full left-2"
                  style="padding: 3px"
                  @click="
                    openCropModel(getImg(22) ? getImg(22).image : logos[22], 23)
                  ">
                  <svg
                    height="17"
                    viewBox="0 0 48 48"
                    width="19"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="black">
                    <path d="M0 0h48v48h-48z" fill="none" />
                    <path
                      d="M34 30h4v-16c0-2.21-1.79-4-4-4h-16v4h16v16zm-20 4v-32h-4v8h-8v4h8v20c0 2.21 1.79 4 4 4h20v8h4v-8h8v-4h-32z" />
                  </svg>
                </p>
                <input
                  id="fileInput23"
                  class="fileInput-hidden"
                  type="file"
                  name="file"
                  aria-invalid="false"
                  accept="image/png, image/jpeg, image/jpg"
                  @change="(event) => updateLogo(23, event)" />
              </div>
            </div>
          </div>
        </div>
        <div
          class="page-num-i"
          :style="{
            borderColor: selectedHeadingsColor,
            color: selectedHeadingsColor,
          }">
          {{
            caseStatement?.case_statement_summary?.split(" ")?.length > 320
              ? Math.floor(caseStatement.projects?.length / 2) +
                Math.floor(caseStatement.success_stories?.length / 2) +
                12
              : Math.floor(caseStatement.projects?.length / 2) +
                Math.floor(caseStatement.success_stories?.length / 2) +
                +11
          }}
        </div>
      </section>
      <div v-if="cropperModelOpen">
        <ImgCropper
          :src="cropperImg"
          :order="cropperOrder"
          @updateCropperImg="updateCropperImg"
          @closeCropperModle="cropperModelOpen = false" />
      </div>
    </div>
  </template>
  
  <script setup>
  // v global
  import global from "@/global";
  
  import { useAuthStore } from "@/stores/auth";
  import { useUserProjectsStore } from "@/stores/projects";
  import { useRoutesManagement } from "@/stores/routesManagement";
  import Swal from "sweetalert2";
  
  import { ref, onMounted, reactive, computed, watch, defineEmits } from "vue";
  
  // Add this import
  import formatToDecimal from "@/composables/formatToDecimal";
  
  // Remove or comment out the store import
  // import { useExpenseStore } from '@/stores/useExpenseStore';
  // const expenseStore = useExpenseStore();
  
  // Add computed property to calculate total expenses from case statement
  const totalExpenses = computed(() => {
    if (!caseStatement.value?.expenses) return 0;
    
    const expenses = caseStatement.value.expenses;
    return (
      parseFloat(expenses.personnel_and_benefits || 0) +
      parseFloat(expenses.professional_and_contractual_fees || 0) +
      parseFloat(expenses.printing_and_publications || 0) +
      parseFloat(expenses.travel_conferences_and_meetings || 0) +
      parseFloat(expenses.marketing_and_communications || 0) +
      parseFloat(expenses.facilities || 0) +
      parseFloat(expenses.programs_cost || 0) +
      parseFloat(expenses.other_expenses || 0) +
      parseFloat(expenses.in_kind_goods_and_services || 0)
    );
  });
  const emit = defineEmits();
  
  //texeditor
  import { QuillEditor } from "@vueup/vue-quill";
  import '@vueup/vue-quill/dist/vue-quill.snow.css';
  const content = ref("<h1>Initial Content</h1>");
  const showEditor = ref(false);
  const currentPorp = ref();
  const currentPorpkey = ref();
  const popOverHeading = ref();
  const textLimit = ref();
  const currentWordCount = ref(0);
  const wordLimitError = ref(""); // Add this line for error message
  
  const setDynamicContent = (props, obj, key, heading, limit) => {
    popOverHeading.value = heading;
    showEditor.value = true;
    content.value = props;
    currentPorp.value = obj;
    currentPorpkey.value = key;
    if (limit) {
      textLimit.value = limit;
    } else {
      textLimit.value = 9999;
    }
    
    // Initialize word count when opening editor
    if (props) {
      currentWordCount.value = stripHtmlAndCountWords(props);
    } else {
      currentWordCount.value = 0;
    }
    
    // Clear any previous error
    wordLimitError.value = "";
  };
  
  // Text editor focus cursor pointer
  const onReady= (editor)=>{
    editor.focus();
  };
  
  // Function to strip HTML and count words properly
  const stripHtmlAndCountWords = (htmlContent) => {
    if (!htmlContent) return 0;
    
    // Create a temporary div to strip HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;
    const textContent = tempDiv.textContent || tempDiv.innerText || '';
    
    // Count words by splitting on whitespace and filtering empty strings
    return textContent
      .replace(/\s+/g, ' ')
      .trim()
      .split(' ')
      .filter(word => word.length > 0).length;
  };
  
  // Handle text changes in the editor
  const onTextChange = (delta, oldDelta, source) => {
    // This function is called when text changes in the editor
    // The actual word count update is handled by updateContent
  };
  
  const getData = () => {
  // Check if word limit is exceeded before saving
  if (currentWordCount.value > textLimit.value) {
    Swal.fire({
      title: "Word Limit Exceeded!",
      text: `You cannot enter more than ${textLimit.value} words. Current count: ${currentWordCount.value} words.`,
      icon: "error",
      confirmButtonColor: "#d33",
      confirmButtonText: "Ok",
    });
    return;
  }

  Swal.fire({
    // title: "Warning!",
    text: "Any formatting changes you make here will only be reflected in the downloaded PDF document. They will not change the narrative text in the individual sections.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#0D423D",
    confirmButtonText: "Ok",
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        let temp = currentPorp.value;
        temp[currentPorpkey.value] = content.value;
        showEditor.value = false;
        currentPorp.value = false;
      } catch (err) {
        // console.log(err);
      }
    }
  });
};
  
  const handleProRationaleGoal= (pro)=>{
    return pro?.find(
                  (item) => item.question_name === "new_project_goals_rationale_goals"
                ).question_answer
  }
  
  const returnProRationaleGoal=(pro)=>{
    return  pro?.find(
                  (item, index) => {
                    if(item.question_name === "new_project_goals_rationale_goals"){
                      return index
                    }
                  }
                )
  }
  
  const updateContent = (newContent) => {
    // Use proper HTML stripping function to count words
    currentWordCount.value = stripHtmlAndCountWords(newContent);

    // Always update the content to allow typing beyond limit
    content.value = newContent;

    // Update error message based on word count
    if (currentWordCount.value > textLimit.value) {
      wordLimitError.value = `You cannot enter more than ${textLimit.value} words!`;
    } else {
      wordLimitError.value = "";
    }
  };
  
  //v Vue Router
  import { useRouter } from "vue-router";
  const router = useRouter();
  
  // v Chart js
  import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
  import ExpensesChart from "@/components/charts/ExpensesChart.vue";
  import RevenuesChart from "@/components/charts/RevenuesChart.vue";
  
  const props = defineProps({
    selectedHeadingsColor: String,
    selectedBodyTextColor: String,
    selectedBackgroundColor: String,
    selectedFontFamily: String,
  });
  
  // console.log("background color -- ", props.selectedBackgroundColor);
  
  //v Pinia Store: Auth
  
  const authStore = useAuthStore();
  const projectsStore = useUserProjectsStore();
  const routesManagementStore = useRoutesManagement();
  
  const tableState = reactive({
    headers: [],
    rows: [],
  });
  
  const logos = ref([
    "/images/page-1.png",
    "/images/page-2.png",
    "/images/our-story-1.png",
    "/images/our-story-2.png",
    "/images/our-story-3.png",
    "/images/our-story-4.png",
    "/images/our-mission-1.png",
    "/images/our-mission-2.png",
    "/images/current-programs-img-1.png",
    "/images/current-programs-img-2.png",
    "/images/current-programs-img-3.png",
    "/images/current-programs-img-4.png",
    "/images/current-programs-img-1.png",
    "/images/current-programs-img-2.png",
    "/images/current-programs-img-3.png",
    "/images/current-programs-img-4.png",
    "/images/call-for-more-img.png",
    "/images/priorities-page-img.png",
    "/images/success-stories.png",
    "/images/contact-page-img-1.png",
    "/images/contact-page-img-2.png",
    "/images/contact-page-img-3.png",
    "/images/contact-page-img-4.png",
  ]);
  
  const showDeleteIcon = ref(false);
  const organization = ref({});
  const caseStatement = ref({});
  const targetAllocation = ref([]);
  const tableStateStore = ref([]);
  const giftPyramidTableState = reactive({
    data: [],
  });
  
  // Add this computed property
  const formattedWaysToGive = computed(() => {
    if (!caseStatement.value?.case_statement_ways_to_give || !Array.isArray(caseStatement.value.case_statement_ways_to_give)) return [];
    
    return caseStatement.value.case_statement_ways_to_give.map(item => ({
      ...item,
      icon: Array.isArray(item.icon) ? item.icon : ['fas', item.icon]
    }));
  });
  
  async function fetchCaseStatementData() {
    try {
      const res = await fetch(`${global.API_URL}/case-statements`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authStore.user.accessToken}`,
          "Content-Type": "application/json",
        },
      });
      let data = await res.json();
      caseStatement.value = data.data;
      
      // Ensure case_statement_ways_to_give is an array
      if (!Array.isArray(caseStatement.value.case_statement_ways_to_give)) {
        caseStatement.value.case_statement_ways_to_give = [];
      }

      if (!waysDataFormat.value.length) {
        caseStatement.value.case_statement_ways_to_give?.forEach((item) => {
          if (item.subOption) {
            item.subOption.forEach((sub) => {
              if (sub.isSelected) {
                waysDataFormat.value.push({
                  ...sub,
                  icon: Array.isArray(sub.icon) ? sub.icon : ['fas', sub.icon]
                });
              }
            });
          }
          if (item.isSelected) {
            waysDataFormat.value.push({
              ...item,
              icon: Array.isArray(item.icon) ? item.icon : ['fas', item.icon]
            });
          }
        });
      }
      caseStatement.value.case_statement_ways_to_give = waysDataFormat.value;
    } catch (err) {
      console.log(err);
    }
  }
  
  async function fetchOrganizationData() {
    try {
      const res = await fetch(`${global.API_URL}/organizations`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authStore.user.accessToken}`,
          "Content-Type": "application/json",
        },
      });
      let data = await res.json();
      organization.value = data.data;
    } catch (err) {
      console.log(err);
    }
  }
  
  function getImg(order) {
    let img = "";
    if (caseStatement?.value?.attachments) {
      caseStatement?.value?.attachments.map((e, i) => {
        if (e.order == order) {
          img = e;
        }
      });
    }
    return img;
  }
  
  const handleProCost = (val) => {
    const pattern = /^<\s*([^>\s]+)[^>]*>/;
    const match = val.toString().match(pattern);
  
    let temp;
  
    if (match) {
      temp = formatToDecimal(parseInt(val.toString().replace(/<[^>]*>/g, "")));
    }
  
    return match ? `${match[0]} ${temp} <${match[1]}>` : formatToDecimal(val);
  };
  
  function getTheText(text, fromIndex, toIndex, secondPage) {
    const pattern = /^<\s*([^>\s]+)[^>]*>/;
    const match = text.match(pattern);
    // console.log("get text -- ", match);
    let data = "";
    let lastIndex = "";
    if (text.length) {
      text = text.replace(/\n/g, "<br>").split(/\s+/);
      if (fromIndex == 0) {
        data = text.slice(fromIndex, toIndex);
        data.map((e, i) => {
          if (e.includes("<br>")) {
            lastIndex = i;
          }
        });
        if (lastIndex >= toIndex - 20) {
          data = data.slice(fromIndex, lastIndex).join(" ");
        } else {
          data = data.join(" ");
        }
      } else {
        data = text.slice(0, fromIndex);
        data.map((e, i) => {
          if (e.includes("<br>")) {
            lastIndex = i;
          }
        });
        if (lastIndex >= fromIndex - 20) {
          text[lastIndex] = text[lastIndex].replace(/<br><br>/g, "");
          data = text.slice(lastIndex, toIndex).join(" ");
        } else {
          data = text.slice(fromIndex, toIndex).join(" ");
        }
      }
    }
  
    if (match) {
      return match[0] + data;
    } else {
      return data;
    }
  }
  function setProperTargetAllocation(totalFundraisingGoal) {
    if (totalFundraisingGoal >= 20000000) {
      targetAllocation.value = [0.5, 0.2, 0.15, 0.15, 0.0, 0.0];
    } else if (totalFundraisingGoal >= 17500000) {
      targetAllocation.value = [0.4, 0.15, 0.15, 0.3, 0.0, 0.0];
    } else if (totalFundraisingGoal >= 15000000) {
      targetAllocation.value = [0.15, 0.2, 0.25, 0.4, 0.0, 0.0];
    } else if (totalFundraisingGoal >= 12500000) {
      targetAllocation.value = [0.15, 0.2, 0.2, 0.45, 0.0, 0.0];
    } else if (totalFundraisingGoal >= 10000000) {
      targetAllocation.value = [0.1, 0.15, 0.15, 0.6, 0.0, 0.0];
    } else if (totalFundraisingGoal >= 7500000) {
      targetAllocation.value = [0.0, 0.3, 0.25, 0.2, 0.25, 0.0];
    } else if (totalFundraisingGoal >= 5000000) {
      targetAllocation.value = [0.0, 0.2, 0.27, 0.17, 0.35, 0.0];
    } else if (totalFundraisingGoal >= 2500000) {
      targetAllocation.value = [0.0, 0.0, 0.0, 0.4, 0.375, 0.225];
    } else if (totalFundraisingGoal >= 1000000) {
      targetAllocation.value = [0.0, 0.0, 0.0, 0.45, 0.25, 0.3];
    } else if (totalFundraisingGoal > 500000) {
      targetAllocation.value = [0.0, 0.0, 0.0, 0.1, 0.3, 0.6];
    } else if (totalFundraisingGoal == 500000) {
      targetAllocation.value = [0.0, 0.0, 0.0, 0.5, 0.4, 0.1];
    }
  }
  
  function buildTableData(prospectRatio, totalFundraisingGoal, prospectNamesArr) {
    let giftAmounts = [5000000, 1000000, 500000, 250000, 100000, 25000];
  
    //v calculate number of gifts needed
    let tempTableData = [];
    let totalPercentage = 0;
    let calculatedTotalFundraisingGoal = 0;
  
    giftAmounts.forEach((ga, idx) => {
      let TargetAllocationTemp = targetAllocation.value[idx];
  
      let targetAllocationValue = 0;
      let numberOfGiftsNeeded = 0;
      let amountByGiftLevel = 0;
  
      let calculatedFundraisingAllocationPercentage = 0;
  
      if (totalPercentage + TargetAllocationTemp * 100 <= 100) {
        targetAllocationValue = totalFundraisingGoal * TargetAllocationTemp;
  
        numberOfGiftsNeeded = Math.ceil(targetAllocationValue / ga);
  
        amountByGiftLevel = numberOfGiftsNeeded * ga;
  
        calculatedFundraisingAllocationPercentage = +(
          (amountByGiftLevel * 100) /
          totalFundraisingGoal
        ).toFixed(1);
  
        calculatedTotalFundraisingGoal += amountByGiftLevel;
        totalPercentage += calculatedFundraisingAllocationPercentage;
      } else {
        TargetAllocationTemp = (100 - totalPercentage) / 100;
  
        targetAllocationValue = totalFundraisingGoal * TargetAllocationTemp;
  
        numberOfGiftsNeeded = Math.ceil(targetAllocationValue / ga);
  
        amountByGiftLevel = numberOfGiftsNeeded * ga;
  
        calculatedFundraisingAllocationPercentage = +(
          (amountByGiftLevel * 100) /
          totalFundraisingGoal
        ).toFixed(1);
  
        if (
          amountByGiftLevel + calculatedTotalFundraisingGoal >=
          totalFundraisingGoal
        ) {
          numberOfGiftsNeeded = Math.ceil(targetAllocationValue / ga) - 1;
          amountByGiftLevel = numberOfGiftsNeeded * ga;
          calculatedFundraisingAllocationPercentage = +(
            (amountByGiftLevel * 100) /
            totalFundraisingGoal
          ).toFixed(1);
        }
  
        calculatedTotalFundraisingGoal += amountByGiftLevel;
        totalPercentage += calculatedFundraisingAllocationPercentage;
      }
  
      tempTableData.push({
        giftAmount: ga,
        numberOfGiftsNeeded: numberOfGiftsNeeded,
        numberOfProspectsNeeded: numberOfGiftsNeeded * prospectRatio,
        amountByGiftLevel: amountByGiftLevel,
        cumulativeGiftAmount: tempTableData[idx - 1]
          ? amountByGiftLevel + tempTableData[idx - 1].cumulativeGiftAmount
          : amountByGiftLevel,
        fundingAllocation: calculatedFundraisingAllocationPercentage,
        prospectNames: {
          names: "",
        },
      });
    });
  
    tempTableData.push({
      giftAmount: "Various",
      numberOfGiftsNeeded: "-",
      numberOfProspectsNeeded: "-",
      amountByGiftLevel: totalFundraisingGoal - calculatedTotalFundraisingGoal,
      cumulativeGiftAmount: totalFundraisingGoal,
      fundingAllocation: parseFloat((100 - totalPercentage).toFixed(1)),
      prospectNames: {
        names: "",
      },
    });
  
    // //v Set Prospect Name field
    tempTableData.forEach((row, idx) => {
      row.prospectNames = prospectNamesArr[idx];
    });
  
    giftPyramidTableState.data = tempTableData;
  }
  
  function buildTableHeaders(prospectRatio, totalFundraisingGoal, prospectNames) {
    buildTableData(
      prospectRatio,
      roundToNearest100000(totalFundraisingGoal),
      prospectNames
    );
    let tempHeaders = [];
    giftPyramidTableState.data.forEach((di) => {
      let obj = {};
      obj.name = "";
      obj.value = `${di.amountByGiftLevel}`;
      obj.order = di.prospectNames?.order;
      tempHeaders.push(obj);
    });
    tableState.headers = tempHeaders.sort((a, b) => a.order - b.order);
  }
  
  function roundToNearest100000(number) {
    return Math.ceil(number / 100000) * 100000;
  }
  
  //v Getting user answer
  import { useFetchAnswer } from "@/composables/fetchAnswer.js";
  import ImgCropper from "../ImgCropper.vue";
  const answerFetch = useFetchAnswer({
    uri: `/stewardships`,
    headers: {
      Authorization: `Bearer ${authStore.user.accessToken}`,
    },
  });
  
  const retrievedUserAnswer = ref(null);
  
  async function getUserAnswer() {
    answerFetch.queryParam.value = ``;
    await answerFetch.fetchData();
    let answer = answerFetch.fetchedData.value;
    retrievedUserAnswer.value = answer;
    let tempPNs = answer.prospectNames.sort((a, b) => a.order - b.order);
    setProperTargetAllocation(answer.totalFundraisingGoal);
    buildTableHeaders(answer.prospectRatio, answer.totalFundraisingGoal, tempPNs);
  
    let tempRows = [];
    answer.stewardships.forEach((ss) => {
      let obj = { ...ss.benefit, id: ss.id };
      tempRows.push(obj);
    });
    tableState.rows = tempRows;
  }
  
  async function getGiftPyramid() {
    try {
      const res = await fetch(` ${global.website_URL}/api/v1/gift-pyramid`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authStore.user.accessToken}`,
          "Content-Type": "application/json",
        },
      });
  
      let data = await res.json();
      tableStateStore.value = JSON.parse(data.data.levels);
    } catch (err) {
      console.log(err);
    }
  }
  
  function redirectTo(url) {
    router.push({ name: url });
  }
  onMounted(async () => {
    await getUserAnswer();
    await getGiftPyramid();
    await fetchOrganizationData();
    await fetchCaseStatementData();
  });
  async function uploadImage(imageData, order) {
    // Perform asynchronous operations here, if needed
    // For example, you can upload the image to a server and get a URL
    emit("emitHandelLodaingScreen", true, "Updating");
  
    let id = getImg(order - 1).id;
    let formData = new FormData();
    formData.append("order", order - 1);
    formData.append("image", imageData);
    formData.append("page_no", "1");
    if (id) {
      formData.append("id", id);
    }
  
    try {
      const res = await fetch(
        ` ${global.website_URL}/api/v1/case-statements/upload`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${authStore.user.accessToken}`,
          },
          body: formData,
        }
      );
      await fetchCaseStatementData();
      await emit("emitToRefresh");
      emit("emitHandelLodaingScreen", false, "");
    } catch (err) {
      console.log(err);
    }
  }
  
  async function updateLogo(order, event) {
    const fileInput = event.target;
    const files = fileInput.files;
    const file = event.target.files[0];
  
    // Check if the user canceled the file selection
    if (files.length === 0 || file == undefined) {
      return;
    } else {
      await uploadImage(file, order);
    }
  }
  
  const cropperModelOpen = ref(false);
  const waysDataFormat = ref([]);
  const cropperImg = ref("");
  const cropperOrder = ref("");
  
  const openCropModel = (img, order) => {
    cropperModelOpen.value = true;
    cropperImg.value = img;
    cropperOrder.value = order;
  };
  const updateCropperImg = (img, order) => {
    uploadImage(img, order);
  };
  
  function openFileInput(input) {
    var fileInput = document.getElementById(`${input}`);
    fileInput.click(); // Programmatically trigger click event
  }
  
  async function deleteImage(id) {
    emit("emitHandelLodaingScreen", true, "Deleting");
    let data = {
      id: id,
    };
    try {
      const res = await fetch(`${global.API_URL}/case-statements/remove-image`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${authStore.user.accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      await fetchCaseStatementData();
      emit("emitToRefresh");
      emit("emitHandelLodaingScreen", false, "");
    } catch (err) {
      console.log(err);
    }
  }
  </script>
  <style scoped>
  * {
    text-decoration: none;
    transition: all 0.3s ease-in-out;
    box-sizing: border-box;
    outline: 0;
  }
  
  html {
    scroll-behavior: smooth;
  }
  
  code,
  kbd,
  samp,
  pre {
    font-size: 14px;
  }
  
  .edit-content {
    position: relative;
  }
  
  .edit-content:after {
    content: "Click to Edit";
    position: absolute;
    top: 2rem;
    left: 1rem;
    width: 100px;
    height: 30px;
    background-color: #ffffff;
    border-radius: 7%;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    opacity: 0;
  }
  
  .edit-content:hover::after {
    opacity: 1;
    z-index: 999;
  }
  
  .page {
    position: relative;
    margin: 2rem auto;
    width: 1056px;
    height: 594px;
    aspect-ratio: 16 / 9;
    box-shadow: 1px 1px 3px 1px #333;
    background-color: #ffffff;
    border-collapse: separate;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    padding: 2rem 3rem;
  }
  .page-bottom-image {
      width: 100%;
      position: absolute;
      bottom: 82px;
      transform: translate(-3rem, 5.2rem);
  }
  .page-bottom-image > div {
      width: 25%;
  }
  .fileInput-hidden {
    display: none;
  }
  
  .company-logo {
    width: 200px;
    height: auto;
    object-fit: contain;
    margin-bottom: 2rem;
  }
  
  .page-num {
    position: absolute;
    right: 2rem;
    bottom: 1.5rem;
    font-size: 12px;
  }
  
  .page-num span {
    margin: 0 0.5rem;
    opacity: 0.5;
  }
  
  .our-story-img {
    width: 40%;
    height: 260px;
    position: absolute;
    right: 0;
    top: 0;
    object-fit: cover;
  }
  
  .annual-operations-img {
    width: 25%;
    height: 360px;
    position: absolute;
    right: 0;
    top: 0;
    object-fit: cover;
    object-position: bottom;
  }
  
  .annual-programs-img {
    position: relative;
    top: -2rem;
    width: calc(100% + 3rem);
    height: calc(100% + 4rem);
    object-fit: cover;
  }
  
  .director-img {
    position: relative;
    top: -2rem;
    left: -3rem;
    width: calc(100% + 3rem);
    height: calc(100% + 4rem);
    object-fit: cover;
  }
  
  .success-stories-img {
    position: relative;
    top: -2rem;
    object-fit: cover;
    object-position: center;
    padding-inline-start: 5rem;
  }
  
  .txt-over-img {
    position: absolute;
    z-index: 1;
    transform: rotate(90deg);
    width: 100%;
    text-wrap: nowrap;
    top: 5rem;
    right: -1.5rem;
  }
  
  .p-rel {
    position: relative;
  }
  
  .top-pattern {
    position: absolute;
    top: 0;
    right: 0;
    width: 200px;
    height: auto;
  }
  
  .bottom-pattern {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 200px;
    height: auto;
  }
  
  .title {
    position: relative;
    border-left: 5px solid #234b29;
    padding-left: 1rem;
    font-weight: 800;
    margin-top: 1.5rem;
    font-size: 18px;
  }
  
  .price {
    margin: 0 1rem;
    padding: 0 1rem;
    background-color: #234b29;
    color: #ffffff;
  }
  
  .text-center {
    text-align: center;
  }
  
  .text-justify {
    text-align: justify;
  }
  
  .text-italic {
    font-style: italic;
  }
  
  .text-small {
    font-size: 14px;
  }
  
  .text-bold {
    font-weight: bolder;
  }
  
  .contact-sec {
    background: linear-gradient(#234b29 50%, #ffffff 50%);
  }
  
  .contact-sec .main-img {
    width: 100%;
    height: 60%;
    object-fit: cover;
    margin-top: 1rem;
  }
  
  .contact-sec .box {
    padding: 2rem;
  }
  
  .contact-sec .box .img {
    width: 50px;
    height: 50px;
    background-color: #234b29;
    border-radius: 3px;
    overflow: hidden;
    object-fit: contain;
  }
  
  .contact-sec .box p {
    font-size: 13px;
  }
  
  .contact-sec .box .box-title {
    font-size: 15px;
    font-weight: 700;
    color: #000000;
  }
  
  .contact-sec .box .img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .box-icon {
    padding: 0.5rem;
    width: 200px;
    box-shadow: 0px 0px 5px 5px #0000000a;
    border-radius: 5px;
    margin: 0.5rem 0;
  }
  
  .box-icon .text {
    font-size: 14px;
    font-weight: 500;
  }
  
  .box-icon img {
    width: 50px;
    height: 50px;
    object-fit: contain;
    display: block;
    margin: 0 auto 0.5rem;
  }
  
  .box-icon:last-child,
  .box-icon:nth-child(7) {
    background-color: #234b29;
  }
  
  .box-icon:last-child .text,
  .box-icon:nth-child(7) .text {
    color: #ffffff;
  }
  
  /* Headings */
  h1 {
    font-size: 48px !important;
    font-weight: 600;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  
  h2 {
    font-size: 33px;
    font-weight: 800;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  
  h3 {
    font-size: 24px;
    font-weight: 500;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  
  h4 {
    font-size: 20px;
    font-weight: 500;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  
  p {
    font-size: 16px;
    font-weight: 300;
    margin-top: 0.5rem;
    margin-bottom: 0.75rem;
    color: #595959;
  }
  
  .txt-small {
    font-size: 14px;
  }
  
  .underline {
    border-bottom: 3px solid;
    width: fit-content;
  }
  
  /* Table */
  table {
    /* border: 1px solid #9fc788; */
    border-collapse: collapse;
  }
  
  table td,
  table th {
    border: 2px solid #9fc788;
    padding: 0.5rem;
  }
  
  table thead {
    background-color: #234b29;
    color: #ffffff;
    font-size: 16px;
    font-weight: 500;
  }
  
  table tbody {
    background-color: #d5e3cf;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
  }
  
  table img {
    width: 35px;
    margin: auto;
    display: block;
  }
  
  /* Text Colors */
  .txt-white {
    color: #ffffff !important;
  }
  
  .txt-green {
    color: #234b29;
  }
  
  .txt-gray {
    color: #595959;
  }
  
  .txt-orange {
    color: #f59d23;
  }
  
  /* Flex Grid */
  .d-flex {
    display: flex;
  }
  
  .align-start {
    align-items: start;
  }
  
  .align-center {
    align-items: center;
  }
  
  .align-end {
    align-items: end;
  }
  
  .j-center {
    justify-content: center;
  }
  
  .fd-col {
    flex-direction: column;
  }
  
  .flex-wrap {
    flex-wrap: wrap;
  }
  
  .j-sb {
    justify-content: space-between;
  }
  
  .j-sa {
    justify-content: space-around;
  }
  
  .j-end {
    justify-content: end;
  }
  
  /* Width */
  .w-1 {
    width: 100%;
  }
  
  .w-2 {
    width: 50%;
  }
  
  .w-3 {
    width: calc(100% / 3);
  }
  
  .w-4 {
    width: 25%;
  }
  
  .w-14 {
    width: 75%;
  }
  
  .w-8 {
    width: calc(100% / 8);
  }
  
  .w-14 {
    width: 75%;
  }
  
  .w-13 {
    width: calc(100% - (100% / 3));
  }
  
  .w-15 {
    width: calc(100% - (100% / 5));
  }
  
  .w-16 {
    width: calc(100% - (100% / 6));
  }
  
  .w-17 {
    width: calc(100% - (100% / 7));
  }
  
  .w-18 {
    width: calc(100% - (100% / 8));
  }
  
  .w-30 {
    width: 30%;
  }
  
  .w-40 {
    width: 40%;
  }
  
  .w-60 {
    width: 60%;
  }
  
  .w-70 {
    width: 70%;
  }
  
  /* Height */
  .h-1 {
    height: 100%;
  }
  
  .h-2 {
    height: calc(100% / 2);
  }
  
  .h-3 {
    height: calc(100% / 3);
  }
  
  .h-4 {
    height: calc(100% / 4);
  }
  
  .min-h-300 {
    min-height: 300px;
  }
  
  /* Padding */
  .p-1 {
    padding: 1rem;
  }
  
  .p-2 {
    padding: 2rem;
  }
  
  .p-3 {
    padding: 3rem;
  }
  
  .p-4 {
    padding: 4rem;
  }
  
  .p-5 {
    padding: 5rem;
  }
  
  .pt-1 {
    padding-top: 1rem;
  }
  
  .pt-2 {
    padding-top: 2rem;
  }
  
  .pt-3 {
    padding-top: 3rem;
  }
  
  .pt-4 {
    padding-top: 4rem;
  }
  
  .pt-5 {
    padding-top: 5rem;
  }
  
  .pl-1 {
    padding-inline-start: 1rem;
  }
  
  .pl-2 {
    padding-inline-start: 2rem;
  }
  
  .pr-1 {
    padding-inline-end: 1rem;
  }
  
  .pr-2 {
    padding-inline-end: 2rem;
  }
  
  .pl-3 {
    padding-inline-start: 3rem;
  }
  
  .pr-3 {
    padding-inline-end: 3rem;
  }
  
  .pb-1 {
    padding-bottom: 1rem;
  }
  
  .pb-2 {
    padding-bottom: 2rem;
  }
  
  .pb-3 {
    padding-bottom: 3rem;
  }
  
  /* Margin */
  .m-0 {
    margin: 0;
  }
  
  .mt-0 {
    margin-top: 0;
  }
  
  .m-auto {
    margin-right: auto;
    margin-left: auto;
  }
  
  .mt-2 {
    margin-top: 2rem;
  }
  
  .mt-3 {
    margin-top: 3rem;
  }
  
  .mt-4 {
    margin-top: 4rem;
  }
  
  .mb-0 {
    margin-bottom: 0;
  }
  
  .mr-2 {
    margin-inline-end: 2rem;
  }
  
  .crt-container{
    height: 450px
  }
  
  /* ------------------------------ */
  /* Theme 3 (Modern Theme) */
  
  .theme-3 .page {
    width: 674px;
    height: 871px;
  }
  
  .theme-3 .theme-3-page-1 .page-1-img {
    position: absolute;
    bottom: 0;
    min-width: calc(100% + 6rem) !important;
    height: 430px;
    transform: translate(-3rem, 2rem);
    object-fit: cover;
    object-position: center center;
  }
  
  .theme-3 h1,
  .theme-3 h2,
  .theme-3 h3,
  .theme-3 h4,
  .theme-3 h5 {
    color: #8c2204;
  }
  
  .theme-3 h1 {
    font-size: 54px;
    font-weight: 400;
  }
  
  .theme-3 h2 {
    font-weight: 400;
  }
  
  .theme-3 p {
    font-size: 14px;
    line-height: 19px;
    color: #000000;
  }
  
  .theme-3 table thead {
    background-color: transparent;
    color: #0e322b;
    font-size: 14px;
    font-weight: 400;
  }
  
  .theme-3 table td,
  table th {
    border: none;
  }
  
  .theme-3 table tbody {
    background-color: transparent;
    font-size: 16px;
    text-align: left;
  }
  
  .theme-3 table tbody tr td {
    padding-top: 1rem;
    border-bottom: 1px solid #9b9b9b7a;
    font-size: 18px;
    font-weight: 500;
  }
  
  .theme-3 table tbody tr td:nth-child(2) {
    color: #8c2204;
  }
  
  .theme-3 .page-num {
    right: auto;
    left: 0;
    bottom: 0;
    font-size: 16px;
    color: #8c2204;
    border-top: 1px solid #8c2204;
    border-right: 1px solid #8c2204;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .theme-3 .letter-page img {
    min-width: calc(100% + 6rem);
    height: 270px;
    transform: translate(-3rem, -2rem);
    object-fit: cover;
    margin-bottom: -2rem;
  }
  
  .theme-3 .our-story-imgs {
    width: calc(100% + 3rem);
    height: calc(100% + 4rem);
    transform: translate(0rem, -2rem);
  }
  
  .theme-3 .our-story-imgs img {
    object-fit: cover;
    display: block;
  }
  
  .page-bottom-image img {
    object-fit: cover;
    height: 183px;
    display: block;
  }
  .theme-3 .our-mission-page {
    padding: 0;
  }
  
  .theme-3 .our-mission-page img {
    object-fit: cover;
    min-height: 436px;
    max-height: 436px;
  }
  
  .theme-3 .bg-brown {
    background-color: #c38112;
  }
  
  .theme-3 .bg-red {
    background-color: #8c2204;
  }
  
  .theme-3 .bg-offwhite {
    background-color: #f2eae0;
  }
  
  .theme-3 .success-stories-img {
    max-width: calc(100% + 3rem);
    height: 100%;
    padding-inline-start: 0;
    width: calc(100% + 3rem);
  }
  
  .theme-3 .success-stories-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .theme-3 ol {
    color: #8c2204;
    font-size: 22px;
    margin: 0;
    padding: 0;
    padding-inline-start: 1.5rem;
  }
  
  .theme-3 ol li {
    padding-inline-start: 0.5rem;
  }
  
  .theme-3 .text-small {
    font-size: 14px;
    line-height: 19px;
  }
  
  .theme-3 .pre-text {
    font-weight: 300;
    white-space: pre-line;
    width: 100%;
    color: rgb(89, 89, 89);
    line-height: 16px;
  }
  
  .theme-3 .priorities-page img {
    min-width: calc(100% + 6rem);
    height: calc(100% + 1rem);
    transform: translate(-3rem, 0rem);
    object-fit: cover;
  }
  
  .theme-3 .learning-page {
    background-position: left;
  }
  
  .theme-3 .learning-page .page-num {
    border-color: #f2eae0;
    color: #f2eae0;
  }
  
  .theme-3 .learning-page .page-num-i {
    border-color: #f2eae0;
    color: #f2eae0;
  }
  
  .theme-3 .page-num-i {
    top: 0;
    right: 0;
    left: auto;
    bottom: auto;
    font-size: 16px;
    color: #8c2204;
    border-bottom: 1px solid #8c2204;
    border-left: 1px solid #8c2204;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .page-num-i {
    position: absolute;
    right: 2rem;
    bottom: 1.5rem;
    font-size: 12px;
  }
  
  .page-num-i span {
    margin: 0 0.5rem;
    opacity: 0.5;
  }
  
  .theme-3 .list-surveys .box .circle {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: 1px solid #8c2204;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 22px;
    color: #8c2204;
  }
  
  .theme-3 .list-ways .box i {
    color: #8c2204;
    font-size: 36px;
    padding-inline-end: 1rem;
  }
  
  .theme-3 .ways-icon {
    /* min-width: 25px;
    max-width: 25px; */
    margin-right: 5px;
  }
  
  .theme-3 .list-ways .box {
    position: relative;
    padding-left: 2rem;
    padding-bottom: 0.5rem;
  }
  
  .theme-3 .list-ways .box svg {
    position: absolute;
    left: 0;
    top: 0.2rem;
    width: 20px;
    height: auto;
    min-height: 29px;
    object-fit: contain;
  }
  
  .theme-3 .donor-table thead {
    border: 1px solid;
  }
  
  .theme-3 .donor-table thead th {
    border: 1px solid;
  }
  
  .theme-3 .donor-table th,
  .theme-3 .donor-table td {
    font-weight: 400;
    font-size: 13px;
  }
  
  .theme-3 .donor-table .checked {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin: auto;
  }
  
  .theme-3 .donor-table tbody tr td {
    padding: 0 1rem;
    height: 60px;
  
    border: 1px solid;
  }
  
  .theme-3 .donor-table thead tr th:first-child {
    width: 500px;
    text-align: left;
    padding-right: 0;
  }
  
  .theme-3 .breakdown-table th,
  .theme-3 .breakdown-table td {
    font-size: 13px;
  }
  
  .theme-3 .breakdown-table .checked {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #c38112;
    margin: auto;
  }
  
  .theme-3 .breakdown-table tbody tr td {
    height: 60px;
  }
  
  .theme-3 .breakdown-table tbody tr td:first-child {
    border: 1px solid;
  }
  
  .theme-3 .breakdown-table tbody tr td:last-child {
    border: 1px solid;
  }
  
  .theme-3 .breakdown-table tbody tr td {
    padding: 0 1rem;
  }
  
  .theme-3 .breakdown-table thead tr th:first-child {
    width: 500px;
    text-align: left;
    padding-right: 0;
  }
  
  .quill-editor {
    flex: 1;
    /* Ensure the editor takes the full height of the container */
    display: flex;
    flex-direction: column;
  }
  
  .editorConDirectorLetter {
    height: 500px;
  }
  
  .editorConOurStory {
    height: 730px;
  }
  
  .editorConPopOver {
    background-color: rgba(0, 0, 0, 0.3);
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    -webkit-backdrop-filter: blur(2px);
    backdrop-filter: blur(2px);
  }
  
  /* Editor styles moved to global CSS to override Quill defaults */
  .wordcount {
    margin: 10px;
    font-size: 14px;
    color: #666;
  }
  
  /* Button styling */
.editorPopover button {
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.editorPopover button:hover {
  opacity: 0.9;
}

/* Word count and error styling */
.wordcount p {
  margin: 0;
  line-height: 1.4;
}

.wordcount .text-red-500 {
  color: #ef4444 !important;
}

.wordcount .text-sm {
  font-size: 12px;
}

.wordcount .font-medium {
  font-weight: 500;
}



/* Editor border styling when word limit is exceeded */
.custom-editor.border-red-500 {
  border: 2px solid #ef4444 !important;
  border-radius: 4px;
}

  </style>
  